
/**
 * allophones for every phoneme segment in the Phoible data,
 * sorted by how often each segment appears as an allophone of the key
 */
export const worldAllophones: Record<string, string> = {
  '˧˥': '˧ ˩˨ ˦ ˩˧ ˨ ˥˩',
  '˧˦': '˦˥',
  '˩˥': '˥',
  '˧˨': '˧ ˧˩ ˧˨˥ ˥˦ ˨',
  '˧˩': '˧ ˥˦ ˧˨ ˨ ˧˩̆ ˧̆',
  '˩˨': '˩ ˦ ˧ ˧˥ ˥ ˥̆ ˨˥̆ ˨˩ ˨',
  '˦˥̆': '˥',
  '˦˩̰': '˦˥',
  '˧˩̰': '˧˩̰ʔ',
  '˨˥˩': '˨˩',
  '˨˩': '˩ ˦ ˧ ˧˥ ˥ ˥̆ ˨˥̆ ˨˩ ˨',
  '˨˥̆': '˦ ˩˨ ˩ ˥̆ ˧',
  '˥': '˦ ˧ ˥˦ ˨˧ ˩˨ ˨ ˩ ˦˥̆ ˥̰ ˦˩ˀ ˩˥ ↓',
  '˦': '˧ ˥ ↓˦ ˩ ˨ ˩˨ ˥̆ ˨˥̆ ˦˨ ˧˥ ˨˧ ˦˥˩ ↓ ↘ ˥˩',
  '˩': '˧ ˩˨ ˨ ˦ ˨˩ ˥˦ ˩̰ ˥ ˥̆ ˨˥̆ ˩˨˧ ˩ˀ ˥˩',
  '˥˧˥': '˨˧ ˥˦',
  '˧˨˥': '˧˨',
  '˨˩˥': '˨˩',
  '˩˨˧': '˩',
  '˩˨˩': '˥˦',
  '˩ˀ': '˩ ˧',
  '˥̰': '˥',
  '˩̰': '˩',
  '˩̤̆': '˧˨̤',
  'ː': 'ɣ ɰ j ∅',
  '<ɯ>': 'ɯ',
  '<ɲ̟>': 'ɲ̟',
  '<o>': 'o',
  '<œ>': 'œ',
  '<q>': 'q',
  '<ɾ>': 'ɾ',
  '<y>': 'y',
  '∅': 'h ə i u e l r ɾ j n ĩ ũ o õ ɑː eː ɑ ɑ̃ ɦ ɨ ʔ ʔ̚ ɣ ɰ ː ʁ s',
  '↘': '˦ ˨',
  '↓': '˦ ˨ ˥ ˥˩',
  '↓˦': '˦',
  'a': 'ã ə aː ɑ æ ʌ ḁ ɐ a̟ ɛ ɒ ɜ ɔ e aˑ a̰ ə̥̆ ə̆ o ă ə̃ ə̥ ai a˞ a̠ i ɑː l̩ ʌ̆ a̤ a̯e ja wa aɪ aˤ aj ãː ɵ ʌː ɐ˞ ɑ̴ a̰ː o̞ ɒː ʊ ĭ ɐ̆ ḁː jwa œ æ̃ au ɐː a̝ ɛi ɛa ɤ ɘ j əː ɤː aʔa ɨ ɾ r ɐ̯ ẵ u æː ɐ̃ ä',
  'ä': 'ea ə ə̝̹ ə̠ ə̟̝ a',
  'ɑ̃ˑ': 'ɑ̃ ɑ̃ː',
  'ă': 'a ă̟ ə ə̆ æ ɑ ɪ ʊ ã ẵ',
  'ã': 'a aː æ̃ ḁ ʌ ɑ ə æ a̟ ɜ ə̥̆ ə̆ ə̃ a̰ ʌː a˞ ʌ̃ ɒ̃ ɒ ʊ ɐ aˑ ɨ̃ a̝ ãˤ ɛ ă ẵ ɑ̃ ãː',
  'ẵ': 'a ã ă',
  'a̝': 'ã aː a',
  'a̟': 'a ə ɐ ɑ æ ɒ ʌ ɜ ã a̟ː ɐ˞ aː a˞ ḁ ɛ ɞ̠ ɜ̠ ɜ̟ ã̟ a̠',
  'a̠': 'a ɐ a̟',
  'a̤': 'a ă̤',
  'ḁ': 'a ə ã æ ə̥ ɜ a̰ aˑ ai e ɒ a˞ a̟ aː ɛ ɵ',
  'a̰': 'a ḁ ə ã aː a̰ː',
  'ă̟': 'ă ə̆',
  'ã̟': 'a̟',
  'ă̤': 'a̤',
  'ɐ': 'a ə ɑ a̟ æ ɔ ɜ ʌ ə̃ ɐi e u aː ɛ ɐ̃ ʁ χ ɒ ɐ̥ ɐː ɑː ɨ ɪ̈ ə̯ ɐ˞ ɶ̝ ɐ̰ a̠ ã ʊ ɤ ɘ aj i o ɐ̝ ʔ ʁ̥ ʑ ʀ ɑ̰ ɑʔ',
  'ɑ': 'a æ ɐ ə ʌ ɔ a̟ aː ɒ ɑ̃ ã ɛ ʌ̆ ɑː e ɜ ɑ̥ ɑi o ɑ̰ ɑʔ ɞ ă ɶ̝ ɑ̆ æ̆ ɐ̆ ø ɐː œ ɑ̟ aˑ ∅',
  'a˞': 'a ə æ ɜ ɐ˞ ai ḁ e ɒ ã aː a̟',
  'ɑ̆': 'æ ɑ æ̆',
  'ɐ̃': 'ɐ a',
  'ɑ̃': 'ɑ ɑ̃ː ɑ̃ˑ ɑ̥ ə ʌ ã æ̃ ə̃ ɑ̃i ∅ e',
  'ɒ̃': 'ɒ ã æ̃ ɒ̃ː ɒː ʔɒ',
  'ɐ̝': 'ɐ',
  'ɑ̟': 'ɑ',
  'ɐ̥': 'ɐ ɶ̝ ɐ̰ ə',
  'ɐ̰': 'ɐ ɶ̝ ɐ̥ ə',
  'ɑ̰': 'ɑ ɐ ɑʔ',
  'ɑ̴': 'a',
  'ɒˑ': 'ɔˑ',
  'ɑˤː': 'ɛːɒ̯ˤ',
  'aː': 'a ãː ã a̟ː ɑː ɑ a̰ː aˑ æ ə ɐ ɐː a̤ː əː ʌː a˞ a̟ aːi ɑ̴ː ɒː ʌ̆ a̰ æ̃ a̝ ɤː ḁ ɛ ʌ yaː ɔː u eː ɛː aɪ',
  'ãː': 'aː a ɒː ə ã',
  'a̟ː': 'aː ɑː a̟',
  'a̤ː': 'aː',
  'ḁː': 'a',
  'a̰ː': 'aː ɑː a a̰',
  'ɐː': 'aː ɐ ɑː a ɑ æː',
  'ɒː': 'ɔː ɒ ɑː aː ãː æː a ɒə ɒ̃ ʔɒ',
  'ɒ̃ː': 'ɒ̃',
  'aːi': 'aː',
  'aɔ̯': 'ao',
  'ɑɔ': 'ao',
  'æ': 'a ɛ ɑ ə e ʌ æː ɐ a̟ ɒ æ̃ ɜ ḁ aː ã ɔ ɑ̆ æ̆ e̞ ə̥ a˞ eː aj ɪ ă æə̯ ai l̩ ɛ̃ æ̤ ɑe əɛ ei aɪ ɛː æˑ æ̰ æ̥ ɛ̠ o æ̝ ʔæ',
  'æ̆': 'æ ɑ̆ ɑ',
  'æ̃': 'ã æ ɒ̃ æ̃ː a aː æ̰ ɑ̃ ə̃ æː ʔæ',
  'æ̝': 'æ',
  'æ̤': 'ɜ æ',
  'æ̥': 'æ',
  'æ̰': 'æ æ̃',
  'æˑ': 'æ ɛˑ',
  'a̯e': 'a',
  'a̯ə': 'ɵ̞̆ ə̆',
  'ɑe': 'æ əɛ ei ɑ̠e',
  'ɒə': 'ɒː',
  'ɑ̠e': 'ɑe',
  'æː': 'ɛː æ e ɛ ɛ̃ː eː æ̃ː ɒː e̞ əː ə̃ː æe̤̯ æe̯ ɜe̯ ə ɜ ɘ ɑː ɐː a æ̃ ʔæ',
  'æ̃ː': 'æː æ̃',
  'æɔ': 'æ̟̝ɔ',
  'æ̟̝ɔ': 'æɔ',
  'æe̯': 'æe̤̯ æː ɜe̯',
  'æe̤̯': 'æe̯ æː ɜe̯',
  'æə̯': 'æ ɛ',
  'aɛ': 'ae',
  'ai': 'a e i ḁ ə æ ɜ ɒ a˞ ei ʌ au aɪ ʌi ãĩ ɛi ae',
  'aɪ': 'a æ ʌ ai ɛ aː iː',
  'ãĩ': 'ai',
  'ɐi': 'ɐ',
  'ɐɪ': 'ɛɪ',
  'ɑi': 'ɑ ə ʌ',
  'ɑ̃i': 'ɑ̃',
  'ɑ̤i': 'ɑ̤',
  'aj': 'a ɔ æ ɛ ɐ ə ɒ',
  'aʲ': 'ɛ',
  'ãʲ': 'ɛ̃',
  'ao': 'ɑɔ au aʊ aɔ̯',
  'au': 'a ʌ ai ʌʊ oʊ aʊ ao ɔ o u',
  'aʊ': 'au ao',
  'ɑʔ': 'ɑ ɐ ɑ̰',
  'aʔa': 'a',
  'b': 'p β mb bʷ bʲ b̚ p̚ pʰ m w b̥ ɓ v bː p͉ bⁿ β̞ ɸ bʱ pʲ bv pː bˠ b̃ mbʷ f b̤ pʷ pɸ bβ βː mp bˡ bʷˠ βʷ ɡ bm u ɣ h ʋ b̚ˀ b̤̥ mˀ ˀp ʔ̚ʷ m̥ w̃ p̚ˀ pˀ pʼ mʲ pˑ p͉ː bˤ bw β̃ p̃ bj t pⁿ p̰ ʙ ʔb bɸ hʲ hʷ ʔ β̥ v̠ p͉̚',
  'ʙ': 'b',
  'b̃': 'b β̃ mb b̃ʷ bʱ bʷ β',
  'bˀ': 'pʼ pˀ',
  'ɓ': 'b ɓʷ p̚ β ɓ̥ m bʷ ɓʲ p ɓ̚ mb ɡb pʼ β̞ mɓ bː bʲ ʔm̰ ʔɓ ʔp̚ p̰ w ɓː b̚ ˀɓ ˀm ʔb',
  'b̚': 'b β bⁿ p bʷ bˡ p͉ b̰ p̚ mb m b̥ ɓ',
  'b̞': 'b̤ b̞̤ β',
  'b̤': 'b β mb̤ b̤ː b̤̚ b̞ b̞̤ pʰ bʱ',
  'b̥': 'b p β pʰ bː bʷ b̚ w p̚ bⁿ bˡ β̥',
  'ʙ̥': 'p',
  'ʙ̩': 'u ũ',
  'b̪': 'v ʋ',
  'b͉': 'p͉ m',
  'b̰': 'pʼ b̚ p̚ mb m p̰ pʰ p pʔ ʔp p̃ ʰp',
  'b͈': 'p',
  'bˤ': 'b',
  'b̚ˀ': 'b',
  'ɓ̚': 'ɓ bʷ',
  'ɓ̥': 'ɓ ɓʷ ɓʲ',
  'b̤̚': 'b̤',
  'b̞̤': 'b̤ b̞ β',
  'b̤̥': 'b',
  'ˀb': 'ˀbʷ ʔ',
  'ˀɓ': 'ɓ ˀm',
  'ˀb͉': 'ʔm',
  'bː': 'b β pː ɓ b̥ bʷ p b̥ː',
  'ɓː': 'ɓ',
  'b̤ː': 'β b̤',
  'b̥ː': 'bː',
  'bf': 'pf',
  'bˠ': 'b bʷˠ p β bʷ b̥ˠ',
  'b̥ˠ': 'bˠ',
  'bʱ': 'b β bʷ b̃ p pʰ b̤',
  'bj': 'b',
  'bʲ': 'b bʷ p mb β bv m mʲ b̚ʲ bʷˠ bⁿ ɓ v p̚ pʲ ʋ b̥ʲ v̠',
  'ɓʲ': 'ɓ ɓʷ ɓ̥',
  'b̚ʲ': 'bʲ',
  'b̥ʲ': 'bʲ',
  'bˡ': 'bⁿ b b̚ b̥',
  'bm': 'm mb b β̞̃ bmʷ',
  'bɰ': 'bʷ',
  'bmʷ': 'bm',
  'bⁿ': 'b b̚ bˡ β p͉ bʷ bʲ b̥',
  'bɸ': 'b p β p̚',
  'bv': 'v b bʲ pf bʷ vf f',
  'bvf': 'pf',
  'bw': 'b mb',
  'bʷ': 'b bʲ β ɓ mb b̚ bʱ pʷ p m mʲ mɓ bⁿ mbʷ b̃ pʷʰ b̥ʷ v bː bˠ b̥ ɓ̚ bɰ bv ʋ',
  'b̃ʷ': 'mb b̃',
  'ɓʷ': 'ɓ ɓʲ ɡb ɓ̥ ɠɓ',
  'b̥ʷ': 'pʷ pʷʰ bʷ',
  'ˀbʷ': 'ˀb',
  'bʷː': 'bʷˤː',
  'bʷˤː': 'bʷː',
  'bʷˠ': 'b b̚ʷˠ bˠ bʲ pʷˠ',
  'b̚ʷˠ': 'bʷˠ',
  'bβ': 'b β',
  'c': 'ɟ k t̠ʃ c̚ ʃ cʰ t j s cç kʲ kʷ ç cː ɡ tʲ k̟ d kʰ q d̠ʒ ts tɕ ɟː r ʔʲ x ˀk ntsʰ tsʰ ɡ̟͈ ʝ ɟ̚ cʲ t̪ ʈ ʲt ʲt̚ ɟ̥ k̃ ɟ̥ʝ ŋkʰ cʷ l ɬ t̰ θ t̠ʃʼ ʔ c̟ ɕ cɕ i i̥ ɲ k̬ kʰː',
  'ç': 'x h j s ɦ c̚ c χ ʝ xʷ cç ɸ ɸː k ɣ j̥ çː sʷ ʃ j̃ x̟ ɟʝ cʰ fː hʲ f çʰ ch ʲh t̠ʃ ɡ ʰj cː ç̻̠ ɟ ɕ cɕ kʰ kx i i̥ ɲ xː',
  'cʼ': 'ɟ̰ ɡ̰ kʼ cʼː',
  'c̚': 'c cʰ ç ɟ cç t̠ʃ d̠ʒ tɕ cː j ɕ cɕ',
  'c̟': 'ɟ̟ t̠ʃ c̟ʰ c̟̚ c',
  'c̠': 'ɟ̠',
  'c̤': 'ɡ ɡ̤̥ ɟ',
  'c̻': 'j̻',
  'ɔ': 'o ɔ̃ ɔː ɛ o̞ a oː ɔ̥ ə ɒ ɑ ʊ õ u ʌ œ e ɞ ɐ ɤ ɔˑ æ ø ɜ ɔə ʊː oa ɔ̰ aj o̝ ɔ̃ː ɔ̆ ɔʌ̯ ʊ̃ ʊ̥ u˞ ui y o̞˞ õ̞ ɔ˞ o̞̥ ṵ u̥ ə̥ uo uɛ uɔ ua ɔ̤ ɔ̥ː ɑː i ɯ uɪ au o̥ oj ɔ̝ ɔ̝ː ɔ̆̃ ja wa w o̠ ɔi',
  'ɕ': 's ʃ z tɕʰ ʒ sʲ s̪ cʰ c ɟ j ç cɕ c̚ cç s͉ χ c̻̟',
  'ɔ̆': 'o̞ ɔ ʊ u o ŏ̞ ɔː y̆ ø̆ ə̆ ɔ̃ ɔ̆̃',
  'ɔ̃': 'ɔ õ ɔː o ɔ̥ õ̞ ũ ə ʊ̃ ʌ̃ ɤ̞̃ ɤ̃ uɛ ɔˑ ɔ̰ ʌ ʊ ɒ ɔ̆ ɔ̆̃ w̃ ɔ̃i ɔ̃ː',
  'c̟̚': 't̠ʃ c̟',
  'ɔ̆̃': 'ɔ ɔ̃ ɔ̆',
  'c̻̟': 'ɕ',
  'ɔ̝': 'ɔ ɤ ɔ̝ː ɔ̤',
  'ɔ̤': 'ɔ ɔ̤̆ ɔ̝ ɔ̤i',
  'ɔ̥': 'ɔ ɔ̃ ʊ̥ u˞ ui y ʊ ɔˑ',
  'ç̻̠': 'ç',
  'ɔ̯': 'w o̯',
  'ɔ̰': 'ɔ ɔ̃ ʌ',
  'ɔ̴': 'u u̥ o',
  'ɔ̤̆': 'ɔ̤',
  'ɔˑ': 'ɔ ɔ̥ ɔ̃ oˑ ɒˑ',
  'ɔ˞': 'ɔ',
  'cː': 'c ɟ ç c̚ ɟː t̠ʃː',
  'çː': 'ç h ɸ xː ɸː',
  'cʼː': 'cʼ t̠ʃʼː',
  'ɔː': 'ɔ oː o ɔ̃ ɔ̃ː ɒː ʊ ɑː o̞ ɔə u o̞ː ŏ̞ ɔ̆ uː ṵː ʊː ɔo̯ ɜo̯ ɔo̤̯ ə o̰ː o̥ ɒ aː yaː øː ɪː ʌ',
  'ɔ̃ː': 'ɔː ɔ ʌ̃ː õː õ̞ː ɤ̞̃ː ɤ̃ː ɑ̃ː o ɔ̃',
  'ɔ̝ː': 'ɔ ɔ̝ ɤ',
  'ɔ̥ː': 'ɔ',
  'ɔ̴ː': 'ʊː',
  'ɔˤː': 'ɔːɒ̯ˤ',
  'ɔːɒ̯ˤ': 'ɔˤː',
  'ɔːʉ': 'oː õː o̞ː',
  'cç': 'ɟʝ c cʰ c̚ kx kʰ ç ɟ ʃ kxʷ txʷ tʰ tx tʲ tʲʰ ɟ̥ʝ k k̚ ɡ j ɕ cɕ',
  'cɕ': 'c ɟ j ɕ ç c̚ cç',
  'cçʰ': 'ʃ',
  'cçʷ': 'ɟʝʷ',
  'ɔə': 'ɔ ɔː',
  'ɔɛ': 'oi',
  'ch': 'ç s h',
  'cʰ': 'kʰ c c̚ cç k̚ tɕʰ k̬ʰ c̬ʰ ç ɟ t̠ʃ k ɡ kx s ɕ c̠ʰ',
  'çʰ': 'ç',
  'c̟ʰ': 'c̟ ɟ̟',
  'c̠ʰ': 'cʰ',
  'c̬ʰ': 'kʰ k̬ʰ cʰ',
  'ɕʰ': 's',
  'ɕᶣ': 'ʃ',
  'ɔi': 'ɔ',
  'ɔ̃i': 'ɔ̃',
  'ɔ̤i': 'ɔ̤',
  'cʲ': 'c',
  'cʝ': 'kɣʷ kɣ k k̚',
  'ɔj': 'əi əj',
  'çk': 'ʰk hk k̥',
  'ɔo̯': 'ɔː ɜo̯ ɔo̤̯',
  'ɔo̤̯': 'ɔo̯ ɔː ɜo̯',
  'cp': 'kp',
  'çp': 'ʰp hp p̥',
  'cʃ': 't d tʲ',
  'çt': 'ʰt ht t̥',
  'çts': 'ʰts hts t̥s',
  'çt̠ʃ': 'ʰt̠ʃ ht̠ʃ t̥ʃ',
  'ɔu': 'əʉ',
  'ɔʊ': 'ou',
  'ɔʌ̯': 'ɔ',
  'cʷ': 'c',
  'çʷ': 'ç̃ʷ',
  'ç̃ʷ': 'çʷ',
  'd': 't r nd ɾ l dʲ ð d̚ dʷ d̪ t̚ ɗ tʰ ɖ t͉ n dⁿ dː d̥ d̠ʒ dz t̪ tʲ dˡ ɺ z ɟ dˤ ʒ d̃ ɹ dʱ t̠ʃ c ʈ tʷ θ nt tʼ tː ð͉ dʷˠ t̪̚ ɽ dn ɾ̥ l̪ ɭ lʲ ʔ dɪ̯ d̠ d̤̥ nˀ ˀd t͈ t͈̚ ŋ d̻ tˑ d̪ⁿ d̪̚ d̪ˡ dˠ ð̞ ɾ̃ md t̻ ʎ dl k t̰ d̠ʒʷ ʷd dʷʲ tç rː ɬ ndʷ d̪θ̪ ɖθ̜ l̪ɬ̪ ɭɬ̜ lʷ rʲ rʷ d̺ d̤ d̺̤ d̪̤ cʃ ɟʒ ts dʔ t͉̚ t̠ t̠ʔ ʈʔ tʔ t̠̚ ʈ̚',
  'd̪̞̤': 'd̪̤ d̪̞',
  'd̃': 'd ɹ l dʱ',
  'd̪̙ˤ': 'd̙ˤ',
  'dˀ': 'tʼ jˀ tˀ',
  'ɗ': 'd l ɗʲ r tʼ ɗ̚ nd ɟ ɗː nɗ ɗʷ ʔʲ ɗ̥ dː ɽ dʷ dʲ t ɖ d̠ʒ ʄ ɾ tʷʼ ʷɗ ɗʷʲ t̚ ɗ̺ ˀd̺ː d̚ ˀɗ ˀn ʔd',
  'd̚': 'd dⁿ t͉ dˡ d̪ ɖ dz ð ð̞ t d̰ nd n t̚ ɽ ɗ r',
  'd̞': 'd̪ d̪̥',
  'd̠': 'ɾ ɖ d d̠͓ l̠ d̠ʲ t̠ ʈ t t̠ʔ ʈʔ tʔ ʔ t̠̚ ʈ̚ t̚',
  'ᶑ': 'ʈʼ ʈ̚ ɽ ʔᶑ ʔl̰ ʔn̰',
  'd̥': 'd t ɾ dɪ̯ ð tʰ t̚ dʔ dⁿ dˡ θ',
  'd̪': 't̪ ð d n̪d̪ d̪̚ ð̞ t d̪̥ d̪ʲ ɾ̪ ɖ θ t̪̚ t̪ʰ ɟ l n d̪ː d̪ð d̻ t̚ dʷ t̻ d̪ⁿ d̪ˡ t͉ dˡ dⁿ dz d̚ d̪j j s ɲ r̪ dʱ tˠ s̪ ʒ dˠ d̠ʒ t̪ⁿ tʰ nd dʲ ɾ ʔd̪ ɹ n̪ t̪ː r d̞ l̪ ɭ d̪θ̪ ɖθ̜ l̪ɬ̪ ɭɬ̜ t̪ʷ d̺ v ð̥ t̪̬ t̪ʰː z d̪ʒ̟',
  'd͉': 't͉',
  'd̰': 't̚ tʰ tʼ nd d̚ n t tʔ ʔt t̃ ʔ',
  'd̠̈': 'ɖ̤ d̤ t̠ʰ ʈʰ tʰ dʱ',
  'ð': 'd d̪ θ t ð̞ t̪ d̪ð ɾ θˑ ðˑ θ͉ t͉ d̪̥ z d̥ d̻ d̪ʲ ðʲ t̚ tʼ t̪θ͉ d̚ ʃ ʐ ɾ̪ t̪̚ t̪ⁿ t̪ː ɟ tʰ ts h ʰsʰ ɹ ʔ v ð̥ ðː',
  'd̺': 'd d̪',
  'd̻': 't̻ d̪ ð ɾ t̪ t̻̚ z̻ s̻ d ð̞',
  'd͈': 't',
  'dˤ': 'd',
  'd̚ˀ': 'ɖ ɖ̚ˀ',
  'ɗ̚': 'ɗ',
  'ɗ̥': 'ɗ ɗʲ ʔʲ',
  'ɗ̪': 'ɾ̰',
  'd̥̚': 'd̠ʒ',
  'd̪̚': 'd̪ d̪ⁿ d d̪ˡ ɾ̪ r̪ d̠ʒ',
  'ɗ̺': 'ɗ ˀd̺ː',
  'd̠͓': 'd̠ ɾ l̠ d̠ʲ',
  'd̪̞': 'd̪̤ d̪̞̤',
  'd̤̥': 'd',
  'd̪̤': 'n̪d̪̤ d̤ d̺̤ d d̪̤̚ d̪̞̤ d̪̞',
  'd̪̥': 'd̪ ð t tʰ t̚ ɾ̪ d̞',
  'ð̞': 'ð d̪ θ͉ d t d̚ t̪ ðː d̻',
  'ð̥': 'ð d̪ v',
  'd̺̤': 'd̤ d̪̤ d',
  'd̙ˤ': 'd̪̙ˤ',
  'd̪ˤ': 't̪ˤ',
  'ðˑ': 'ð θˑ θ',
  'ˀd': 'd',
  'ˀɗ': 'ɗ ˀn',
  'dː': 'd t̚ ɺ ɗ',
  'd̪̥ˤː': 'd̪ˤː',
  'ɗː': 'ɗ',
  'd̤ː': 'd̤',
  'ðː': 'ð ð̞',
  'ˀd̺ː': 'ɗ̺ ɗ',
  'dːʒ': 'd̠ʒ',
  'db': 'ɡb',
  'd̪ð': 'ð d̪ d̪ʲ t̪ t̪θ͉',
  'dˠ': 'd dˡ dʷˠ dⁿ d̪ t̪',
  'd̪ˠ': 'd̪̥ˠ',
  'd̪̥ˠ': 'd̪ˠ',
  'dʱ': 'd l d̪ d̃ d̠̈ ɖ̤ d̤',
  'ɗʱ': 'ɽʱ',
  'dɪ̯': 'd d̥ ɾ',
  'dj': 'j̰ jʔ',
  'dʲ': 'd dʷ ɟ j j̃ d̠ʒ nd tʲ t ɲ n̠d̠ʒ dʷˠ tʲʰ nʲ ɗ d̪ ʷd dʷʲ lʲ tʷʲ ɟʒ ɡʲ',
  'ɗʲ': 'ɗ ʔʲ ɗ̥ d̠ʒ ɟ ʷɗ ɗʷʲ',
  'd̠ʲ': 'd̠ d̠͓ ɾ l̠',
  'd̪j': 'd̪',
  'd̪ʲ': 'd̪ ð d̪ð',
  'ðʲ': 'ð',
  'd̻ʲ': 'd̻ⁿʲ d̻ˡʲ',
  'dl': 'l lː l̥ ɮ ɬ ʎ d',
  'dˡ': 'd dⁿ t͉ d̪ ɖ dz d̚ dʷˠ dˠ ɾ dʔ d̥',
  'dɮ': 'tɬ',
  'd̪ˡ': 'd̪ⁿ d̪ d̪̚ d',
  'd̻ˡʲ': 'd̻ⁿʲ d̻ʲ',
  'dn': 'n nd d ɾ ŋ ɡŋ dnʷ',
  'dⁿ': 'd dˡ d̚ t t͉ d̪ ɖ dz dʷˠ dˠ ɾ dʔ d̥',
  'd̪ⁿ': 'd̪ d̪̚ d d̪ˡ',
  'd̪n̪': 'd̪n̪ʷ',
  'd̻ⁿʲ': 'd̻ˡʲ d̻ʲ',
  'dnʷ': 'dn',
  'dɳʷ': 'ɖɳ ʲɖɳ',
  'd̪n̪ʷ': 'd̪n̪',
  'dnz': 'nz',
  'dr': 'r ɾ d̠ʒ',
  'd̪ʉ': 't̪',
  'dʷ': 'd dʲ nd d̪ ɾ r ɗ ndʷ t lʷ',
  'ɗʷ': 'ɗ nɗ',
  'dʷˠ': 'd dˡ dⁿ dˠ dʲ',
  'dʷʲ': 'd ʷd dʲ',
  'ɗʷʲ': 'ɗ ʷɗ ɗʲ',
  'dz': 'd̠ʒ z ts ndz ʒ d dzʲ tsʰ dzʷ s dʑ tz̤̥ z̪ t͉s n ŋ d̻z̻ t͉ dˡ d̪ dⁿ ɖ d̚ dzʷˠ t̪s r t̠ʃ d̠ʒʷ ʷdz dzʷʲ ɟʝ dzː dzs d̠ʒʃ zs ʒʃ z̻ zʲ ʑ',
  'dzˀ': 'tsʼ',
  'dz̤': 'dzʱ dʑ̤',
  'dz̥': 't̪s ts tsʰ',
  'dz̰': 'tsʼ',
  'dʑ': 'ʑ dz z',
  'dʑ̤': 'dzʱ dz̤',
  'd̪̞̤z̪̞̤': 'd̤z̤ d̪̞z̪̞',
  'd̟ʑ̟': 'ɟ',
  'd̤z̤': 'd̪̞̤z̪̞̤ d̪̞z̪̞',
  'd̥z̥': 'ts t̟s̟ t̪s̪ t̠ʃ',
  'd̪z̪': 'dz̪ʲ',
  'd͉z': 't͉s d͉zː',
  'd̻z̻': 'dz d̠ʒ',
  'd̪̞z̪̞': 'd̤z̤ d̪̞̤z̪̞̤',
  'dzː': 'd̠ʒː dz',
  'd͉zː': 'd͉z t͉s',
  'dzʱ': 'dz̤ dʑ̤',
  'dʑᶣ': 'd̠ʒ',
  'dzj': 'j ʑj',
  'dzʲ': 'dz dzʷˠ tsʲ ʷdz dzʷʲ',
  'dz̪ʲ': 'd̪z̪',
  'd̠z̠ʲ': 'd̠̥z̠̥ʲ',
  'd̠̥z̠̥ʲ': 'd̠z̠ʲ',
  'dzs': 'z dz d̠ʒ ʒ d̠ʒʃ zs ʒʃ',
  'dzʷ': 'dz ndz d̠ʒ',
  'dzʷˠ': 'dzʲ dz',
  'dzʷʲ': 'dz ʷdz dzʲ',
  'ɗʒ': 'ʄ',
  'd̠ʒ': 't̠ʃ dz ʒ n̠d̠ʒ z j d̠ʒʷ ɟ d̠ʒʲ d t̠ʃ͉ d̠ʒː ts ʝ t̠ʃʰ k ɡ ʃ r dʲ c ʒʲ ɟ̟ ɟ̟̚ ɲ d̠ʒ̥ zʲ ɟ̚ˀ c̚ ʐ ɽ ɾ ɺ d̻z̻ ʄ q ñ tʂ dr d̪ d̪̚ ʒ̥ dːʒ s̰ ɗʲ ɗ ndz dzʷ dʑᶣ ɟʝ d̠ʒʰ t̠ʃ̚ n̠d̠ʒʷ dzs d̠ʒʃ zs ʒʃ d̥̚ t̬ʃ t̠ʃʰː ʒ̊ ʑ',
  'd̠ʒˀ': 't̠ʃʼ',
  'd̠ʒ̤': 'n̠d̠ʒ̤',
  'd̠ʒ̥': 'd̠ʒ ʒ',
  'd̠ʒ͉': 't̠ʃː t̠ʃ͉',
  'd̠ʒ̰': 't̠ʃʼ',
  'd̪ʒ̟': 'd̪',
  'd̪ʒ|d̠ʒ': 't̪ʃ|t̠ʃ',
  'd̠ʒː': 'd̠ʒ dzː',
  'd̠ʒʰ': 'd̠ʒ',
  'd̠ʒʲ': 'd̠ʒ d̠ʒʷ ɡ̟ʲ z zʲ t̠ʃʲ d̠ʒʷˠ',
  'd̠ʒʃ': 'z dz d̠ʒ ʒ dzs zs ʒʃ',
  'd̠ʒʷ': 'd̠ʒ d̠ʒʲ d r dz n̠d̠ʒ n̠d̠ʒʷ',
  'd̠ʒʷˠ': 'd̠ʒʲ',
  'dʔ': 'd ɾ dⁿ dˡ d̥',
  'd̪θ̪': 'd d̪ l̪ t t̚ ɖ ɭ ɖθ̜ l̪ɬ̪ ɭɬ̜',
  'ɖ': 'ʈ d ɽ t d̪ ɖʲ ʈ̚ ɾ ɖ̚ ɳɖ ʈʰ t̚ d̠ d̚ˀ ɖ̚ˀ ʈ͉ ɖⁿ ɖˡ t͉ dˡ dⁿ dz d̚ ɖʷˠ ɟ ɖ̃ ɖʱ nd ɗ ɖ̥ l r l̪ ɭ d̪θ̪ ɖθ̜ l̪ɬ̪ ɭɬ̜ ʈʷ ʲʈ t̠ t̠ʔ ʈʔ tʔ ʔ t̠̚',
  'ɖ̃': 'ɖ',
  'ɖ̚': 'ɖ ɖⁿ ɖˡ',
  'ɖ̞': 'ɖ̤ ɖ̞̤',
  'ɖ̤': 'ɽ̤ d̠̈ d̤ ɳɖ̤ ɖ̤̚ ɖ̞̤ ɖ̞ t̠ʰ ʈʰ tʰ dʱ',
  'ɖ̥': 'ɖ ɽ',
  'ɖ̻': 'ʈ̺',
  'ɖ̚ˀ': 'ɖ d̚ˀ',
  'ɖ̤̚': 'ɖ̤',
  'ɖ̞̤': 'ɖ̤ ɖ̞',
  'ˀɖ': 'ɽ',
  'ɖː': 'ʈː',
  'ɖʱ': 'ɖ',
  'ɖʲ': 'ɖ ɽ ɖʷˠ',
  'ɖˡ': 'ɖⁿ ɖ̚ ɖ',
  'ɖⁿ': 'ɖˡ ɖ̚ ɖ',
  'ɖɳ': 'ʲɖɳ dɳʷ',
  'ɖr': 'ɖrʷ ɖrʲ',
  'ɖrʲ': 'ɖr',
  'ɖrʷ': 'ɖr',
  'ɖʷˠ': 'ɽ ɖ ɖʲ',
  'ɖʐ': 'ʐ ʈʂ',
  'ɖθ̜': 'd d̪ l̪ t t̚ ɖ ɭ d̪θ̪ l̪ɬ̪ ɭɬ̜',
  'e': 'ɛ ẽ i eː ɪ ə e̞ ei e̥ a æ o ɛ̃ ɛː ɨ ɘ ɤ ḛ æː ɔ ø ɛi ɛa eˑ ɜ ĕ ɐ ʌ e̝ ɑ ai ɪ̈ ie e̠ ɑː œ ∅ eʔ j e̠̞ oɤ ɪə̯ ɛə ɛ̠ ḁ ɒ a˞ ɪ̥ i̥ ə̴ ɛ̆ eɛ̯ ɛ̥ ɛ̯ ḭ ɪ̰ ɪ̆ ɪ̤ ë eɪ ĩ ɛ̞ ʲe ɛ̰ i̯ e̯ ɛˑ ej eˤ ɛᵊ ʊ ẽː õ ɑ̃ ʔe e̤ ɛ̃ː ɯ',
  'ë': 'e ə ɛ',
  'ĕ': 'ə̆ e ə̥̆ eː ẽ',
  'ẽ': 'e ɛ̃ ɛ eː e̥ ẽ̞ e̞ eˑ ɪ ĕ ẽː ə ẽi ʔe e̤ ĩ',
  'ə̟̝': 'ə ə̝̹ ə̠ ä',
  'ə̝̹': 'ə ə̠ ä ə̟̝',
  'e̘': 'ẽ̘',
  'e̙': 'ɪ̠̙ ɪ̙ ẽ̙',
  'e̝': 'e ɪ ə eː e̝ː ɛ ej j',
  'e̞': 'e ɛ ɪ e̞̥ e̠̞ e̞̰ ẽ̞ ɤ æ ɛː ĕ̞ ɤ̞ ie̞ ẽ eː ee̞ oɤ ə o ɜ i˞ i e̞ˑ ɛ̆ e̞ː e̞̰ː ẽ̞̰ æː iɛ e̞̤ e̯',
  'e̠': 'e ɛ',
  'e̤': 'ĕ̤ e̤i e ẽ',
  'e̥': 'e ẽ ɛ eˑ eː',
  'e̯': 'j ʝ j̃ ɪ̯ z e̞ e i̯ ɛ i eː',
  'ḛ': 'e i ḭ ɪ̰ ɪ eʔ ɘ',
  'ẽ̘': 'e̘',
  'ẽ̙': 'e̙',
  'ĕ̞': 'e̞ ɛː ɛ̆ e̞̥',
  'ẽ̞': 'e̞ ẽ ɛ̃ ɛ ẽ̞̰ e̞̥ e̞̰',
  'ĕ̤': 'e̤',
  'ə': 'a e ɛ ʌ ɪ i ə̃ ɐ ɨ æ o ɤ ɑ ɔ ɒ ɵ ɜ ə̥ ʊ a̟ ʉ u ḁ ã ɯ ø aː ə̠ ɘ ɛ̃ ∅ ə̯ ø̞ a˞ ă ə̰ a̰ ɵ̠̞ ə̟ əˑ ə̝ jə oː eː j œ ɔ̃ e̝ ʏ ʁ χ ə̤ ɪ̈ oɤ e̞ ə̆ ai l̩ ɶ̝ ɐ̰ ɐ̥ ɰə o̞ ɘ̟ ɜ̠ wə jwə ɔː ë iː uː ɛː æː ɤː õ ɑi ɑ̃ aj jɪ ej ʌˤ ɛ̝ ɛ̝ː əː ĩ o̝ w ẽ ẽː ə̝̹ ä ə̟̝ a̽ ʑ ʀ əi ə̤i ɞ ãː r ɹ ɾ',
  'ɘ': 'e ə ɪ̈ i ɤ ɯ ei ɤ̞ ĭ ĭ̥ ɵ̠̞ ə̠ ə̟ ɛ iæ iɛ ia iɘ ɪ ɪ̠ a ɑː ɐ æː eː eʔ ḛ',
  'eˑ': 'e eː ɛˑ ẽ e̥ aˑ ɛ',
  'e˞': 'ɪ̈ ɪ',
  'eˤ': 'e',
  'ə̈': 'ö ü',
  'ə̆': 'a ə̥̆ ĕ ã ă ɵ̞ ə ɜ ʌ ă̟ ɒ̆ ɔ̆ ø̞ a̯ə ɵ̞̆ j ɣ',
  'ə̃': 'ə ɐ a ɨ ã ə̯ ɤ ʊ ə̥̃ əˑ ɛ ɛ̃ ɨ̃ ɨ̰ ɑ̃ æ̃ əː ʌ ŋ ɴ',
  'e̠̞': 'e̞ e ɛ',
  'e̞̤': 'e̞',
  'e̞̥': 'e̞ e̞̰ ĕ̞ ɛ ẽ̞ ẽ̞̰',
  'e̞̯': 'j',
  'e̞̰': 'e̞ e̞̥ e̞ː e̞̰ː ɛ ẽ̞ ẽ̞̰',
  'ẽ̞̰': 'ɛ ẽ̞ e̞ e̞̥ e̞̰',
  'ə̝': 'ə',
  'ə̟': 'ə ɤ̞ ə̟̆ ɵ̠̞ ə̠ i ɘ',
  'ə̠': 'ə ɵ̠̞ i ɘ ə̟ ə̝̹ ä ə̟̝',
  'ɘ̟': 'ə ɜ̠',
  'e̞ˑ': 'e̞',
  'ə̤': 'ə ɤ ʌ əi ə̤i',
  'ə̥': 'ə a ḁ æ ɛ ə̰ ʌ ɒ ɔ ɵ',
  'e̞˞': 'oɤ˞ ɤ˞',
  'ə̯': 'ə ə̃ ɐ',
  'ə̰': 'ə ə̥',
  'ɘ̯': 'ʌ̯ ɜ̯ ɵ̞̯',
  'ə̟̆': 'ə̟ ɤ̞',
  'ə̠̃': 'ə̠̃i',
  'ə̥̆': 'a ə̆ ã ʌ ĕ',
  'ə̥̃': 'ə̃',
  'əˑ': 'ə ə̃ aˑ',
  'eː': 'e ɛ ɛː ẽː iː ẽ ɪː eˑ e̞ː i ei æ æː ə e̞ ḛː əː ɤe e̠ː eə̯ ĕ e̤ː ɜ ɘ ie e̝ ɪ ʲeː i̯ e̯ e̥ eˤː uː ɤː aː eːɐ ɜː ɪə eɪ o õ ∅ ɑː ʔe',
  'ẽː': 'eː ɛ̃ː ẽ̞ː e ẽ ə',
  'e̝ː': 'e̝',
  'e̞ː': 'eː ee̞ː ei e̞ e̞̰ e̞̰ː ɛː',
  'e̠ː': 'eː',
  'e̤ː': 'eː',
  'ḛː': 'eː ɛː',
  'ẽ̞ː': 'ẽː ɛ̃ː',
  'əː': 'aː eː ə̃ː æː a ɤː ɨ ɛː uː iː ə ə̃',
  'eˤː': 'eː',
  'ə̃ː': 'əː æː',
  'e̞̰ː': 'e̞ː e̞ e̞̰',
  'ə̴ː': 'ɪː',
  'eːɐ': 'eː',
  'eːə̯': 'ḭː iː',
  'eːi': 'iː',
  'ea': 'ä',
  'ee̞': 'e̞',
  'eə': 'e̽ə',
  'eə̯': 'eː',
  'e̽ə': 'eə',
  'ee̞ː': 'e̞ː',
  'eɛ̯': 'e i ei ɛ̆ ɪ',
  'əɛ': 'æ ɑe ei',
  'ei': 'e ɛ i eː ɛi ɘ e̞ː ɛa ɛ̆ ɪ eɛ̯ ai ɛ̥ æ ɑe əɛ iː',
  'eɪ': 'ɛ e eɪ̯ eː ɪə',
  'eɪ̯': 'eɪ',
  'ẽi': 'ẽ',
  'e̤i': 'e̤',
  'e̯ɪ': 'ɪ',
  'əi': 'əj ɔj ə ə̤ ɤ ʌ',
  'əɪ': 'ɜɪ',
  'ə̤i': 'ə̤ ə ɤ ʌ',
  'ə̯ɪ': 'ɪ',
  'ə̠̃i': 'ə̠̃',
  'ə̯iː': 'iː',
  'ej': 'ɛ e e̝ ə',
  'eʲ': 'ẽʲ',
  'ẽʲ': 'eʲ',
  'əj': 'əi ɔj',
  'əɹ': 'ɹ',
  'eʉ': 'ɛʉ eʊ ɛʊ əʉ əʊ',
  'eʊ': 'ɛʉ ɛʊ əʉ eʉ əʊ',
  'əʉ': 'ɔu ɛʉ eʊ ɛʊ eʉ əʊ',
  'əʊ': 'ɛʉ eʊ ɛʊ əʉ eʉ ɵ o u ɤ',
  'eʔ': 'e ḛ ɘ',
  'ɛ': 'e ɛ̃ æ ə ɛː ɪ a e̞ eː i ɔ ɛ̥ ẽ œ ʌ o ɜ ɛ̠ ei ɑ ɛi ɒ æː ɐ ɛə ɛ˞ ɛa ɪ̃ j ɛˑ ə̥ ɛ̯ ɛ̰ e̥ ɨ ɛe aj ɛ̃ː ɛ̆ ɞ ɛʌ̯ æə̯ ɪ̈ ø o̞ ẽ̞ ẽ̞̰ e̞̥ e̞̰ a̟ ɛɜ̯ ie iæ iɛ ia iɘ ɘ øː e̠ e̠̞ ɜ̆ ɛ̥ː ɑː ë ə̃ ɛʌ eɪ ɛ̞ aɪ ɤ ĩ i̯ e̯ ej e̝ aʲ ɛ̝ ɛ̝ː ɵ ḁ ã aː ɛ̆̃ ɛ̤ iː ɪː eˑ',
  'ɛ̆': 'ɛ e i ei ɪ eɛ̯ ɛː e̞ ĕ̞ ɛ̃ ɛ̆̃',
  'ɛ̃': 'ɛ ẽ e ɛː ɛ̥ ə ẽ̞ ɜ ɛ̃ː ɛ˞ æ ɛ̠ øː ɛ̃ˑ ɛˑ ə̃ ɛə ãʲ ɛ̆ ɛ̆̃ ɛ̃i',
  'ɛ̆̃': 'ɛ ɛ̃ ɛ̆',
  'ɛ̝': 'ɛ ə ɛ̝ː',
  'ɛ̞': 'ɛ e',
  'ɛ̠': 'ɛ e ɛ̃ ɜ æ',
  'ɛ̤': 'ɛ̤̆ ɛ ɛ̤i',
  'ɛ̥': 'ɛ ɛ̃ e ei ɛˑ',
  'ɛ̯': 'ɛ j e',
  'ɛ̰': 'ɛ e',
  'ɛ̤̆': 'ɛ̤',
  'ɜ': 'a ə ɛ æ ʌ ɐ a̟ e ɔ ɑ ɞ ḁ a˞ ã ɞ̠ ɜ̠ ɜ̟ ɛ̃ e̞ ə̆ ai ɒ ɛ̠ æ̤ eː ɛː æː ɜ̃',
  'ɞ': 'ɔ ɜ ɑ ɛ ʌ ə',
  'ɛ˞': 'ɛ ɛ̃',
  'ɜ̆': 'ɛ',
  'ɜ̃': 'ɜ',
  'ɛ̃ˑ': 'ɛ̃ː ɛ̃',
  'ɜ̟': 'ɜ a̟ ɞ̠ ɜ̠',
  'ɜ̠': 'ɜ a̟ ɞ̠ ɜ̟ ə ɘ̟',
  'ɞ̠': 'ɜ a̟ ɜ̠ ɜ̟',
  'ɜ̯': 'ʌ̯ ɵ̞̯ ɘ̯',
  'ɛː': 'ɛ eː æː e ɛ̃ː ɛ̃ e̞ i ɪː ɛə ɛ̆ ĕ̞ œ æ ə ɜ ɛe ḛː e̞ː əː ɪ iː aː ɜː',
  'ɛ̃ː': 'ɛː æː ɛ̃ ɛ ẽː ẽ̞ː ɛ̃ˑ e',
  'ɛ̝ː': 'ɛ ə ɛ̝',
  'ɛ̥ː': 'ɛ',
  'ɜː': 'eː ɛː ɪː',
  'ɛːɒ̯ˤ': 'ɑˤː',
  'ɛa': 'e ɛi ɛ ei i a',
  'ɛe': 'ɛ ɛː',
  'ɛə': 'ɛ ɛː e ɛ̃',
  'ɛᵊ': 'e',
  'ɜe̯': 'æe̤̯ æe̯ æː',
  'ɛɜ̯': 'ɛ',
  'ɛi': 'e ɛ ei ɛa i a ai ae',
  'ɛɪ': 'ɐɪ',
  'ɛ̃i': 'ɛ̃',
  'ɛ̤i': 'ɛ̤',
  'ɜɪ': 'əɪ',
  'ɜo̯': 'ɔo̯ ɔː ɔo̤̯',
  'ɛʉ': 'eʊ ɛʊ əʉ eʉ əʊ',
  'ɛʊ': 'ɛʉ eʊ əʉ eʉ əʊ',
  'ɛʌ': 'ɛ ʌ',
  'ɛʌ̯': 'ɛ',
  'f': 'v ɸ fʷ fʲ p pʰ β fː w fˠ h b pɸ ɰ fˑ f̃ pf ʄ v̥ p̚ ɰ̥ fˤ pfʼ v͈ fʷˠ p̪ pʷˠʰ pʲʰ ç ɸː hʲ ɸʷ pw fw pʷ hw fʰ ɱf vʷ vʲ s pʲ pː bv θ t̪ f̬ v̩ f͉ x ʋ v̼',
  'f̃': 'f ɸ fʰ fʲ fʷ',
  'f̩': 'u v̩ u̥ ʊ uɘ',
  'f͉': 'v ʋ f',
  'f̬': 'f',
  'fˑ': 'f fː',
  'fˤ': 'f',
  'fː': 'f ɸː ɸ fˑ fˤː h ç hʲ pː pʰː',
  'fˤː': 'fː',
  'fˠ': 'f fʷˠ fʷ',
  'fʰ': 'fʲ fʷ f̃ f',
  'fʲ': 'f fʷ v fʰ f̃ vʷ vʲ p ɸ pʲ',
  'fɰ': 'fʷ',
  'fw': 'f',
  'fʷ': 'f fʲ v ɸ ɸʷ fʰ f̃ vʷ vʲ fˠ ʃʷʲ fɰ',
  'fʷː': 'fʷˤː',
  'fʷˤː': 'fʷː',
  'fʷˠ': 'fˠ f',
  'ɤ̞': 'ɤ̞̥ e̞ ə̟ ə̟̆ i ĭ ĭ̥ ɘ ɯ̞ ɤ o̞ o ɯ ɤ̞̆',
  'ɤ˞': 'oɤ˞ e̞˞',
  'ɢ': 'ʁ q ɣ ʀ ɢʁ qʰ qχ χ q̚ k ɡ ɢʲ ʔ ʕ ɢ̥ ɣ̥',
  'ɢ̆': 'r ʀ ɾ',
  'ɤ̞̥': 'ɤ̞ ɯ ɤ̞̆',
  'ɠ': 'ɡ ʔ wˀ ɡʷ ɡʲ ɠ̥ ɡ̚',
  'ʛ': 'qʼ qxʼ ʛ̥',
  'ɢ̥': 'ɢ ʀ q qʰ',
  'ɣ': 'ɡ k x ʁ ɣʷ h k̚ ɰ ʝ j q ɡʲ ɣʲ ŋɡ kʰ ɡʷ ɢ χ ɡɣ ɦ r ɟ ɣ̃ kʼ xˑ ɣˑ xʲ ɣ̟ ʕ ɡʱ q̚ ç ŋ ɡ̥ ɡː ɣː b ɣ̞ ɡ̊ qχ ʀ ŋk xʷ w ɹ ɯ̯ t̠ʃ kⁿ ɡ̃ ɡb ʷɣ ɣʷʲ ə̆ ɡx ɣx uu̯ ɣ̊ ʁ̞ ɡ̤ ɡ̞̤ ɡ̞ ɣ̥ ɡ̚ ɡk ː ∅ k͉',
  'ɡ': 'k ɣ ɡʷ ɡʲ ŋɡ ɡ̚ kʰ k̚ ɟ ɡ̟ x ŋ ɡː ʁ ʔ k͉ ɡ̥ ɰ q kʲ kʷ ɡɣ ɡⁿ kː ɡ̠ ɣʷ ɡʱ ɣ̞ ɡ̊ k̟ c ɠ ɡ̟ʲ j d̠ʒ h ŋk kʼ ɡʷʲ ɡv t ɡ̃ w b ɡŋ q̚ kx ɡ̥̊ ɡ͉ ɡ̤̥ c̤ ŋɡ̟ ŋˀ k͈̚ k͈ ɡˤ ˀk͉ kˑ k̟ː ɡʷˠ ɢ ɣʲ ʕ ɡw nɡ χ θ mɡ ɡj ɡɟ ç ɦ kⁿ ɡ̥ʲ kʲʰ k̰ kf ɡˠ kp ɡb ʷɡ ɣː cʰ cç t̠ʃ ŋɡʷ ʝ ɡx ɣx ɡ̤ ɡˡ ɣ̊ k̬ kʰː k͉̚ ɡk',
  'ɣ̃': 'ɣ',
  'ɡ̃': 'ɡ ɡʱ ɡʷ ɣ',
  'ɡ̊': 'ɡ ɣ k k̚ ɡⁿ ɡˡ ɣ̊',
  'ɠ̥': 'ɠ',
  'ʛ̥': 'qʼ qxʼ ʛ',
  'ɡˀ': 'kʼ',
  'ɡ̚': 'ɡ k ɡⁿ k̚ ɡ̟ k͉ ɡ̰ ŋ̚ ɡʷ ɠ ɣ ɡː ɡk',
  'ɣ̞': 'ɡ ɣ k ɰ',
  'ɣ̟': 'ɣ j ʝ x',
  'ɡ̞': 'ɡ̤ ɡ̞̤ ɣ',
  'ɡ̟': 'ɡ ɡ̠ k k̟ ŋɡ ŋɡ̟ ŋˀ ɡ̟̚ ɡ̚ kˑ kː k̟ː k̟͉ ɟ ɡʱ',
  'ɡ̠': 'ɡ ɡ̟ ɡʱ ɡʷ',
  'ɣ̥': 'ɣ ɢ',
  'ɡ̥': 'ɡ ɣ k ɡː kʰ',
  'ɡ͉': 'ɡ k͉',
  'ɡ̰': 'k cʼ ɟ̰ kʼ ɡ̚ k̚ ŋ̚ kʰ kʔ ʔk k̃ ʰk',
  'ɡ̥̊': 'ɡ',
  'ɡ̞̤': 'ɡ̤ ɡ̞ ɣ',
  'ɣˑ': 'ɣ xˑ',
  'ɢǃ': 'ɴǃɢ',
  'ɡǃkʰ': 'ɡǃqʱ',
  'ɢǃqʰ': 'ɴɢǃqʰ',
  'ɡǃqʱ': 'ɡǃkʰ',
  'ɡˤː': 'ɡː',
  'ɢː': 'qː',
  'ʛː': 'qʼː ʛ̥ː',
  'ɣː': 'ɣ ɡ ɰ ʝ',
  'ɤː': 'ɤ oː ɤ̞ː o̞ː ɯː a aː əː ə ɤ̃ eː',
  'ɡː': 'ɡ ɣ kː ɡˤː k̚ ɡ̥ ɡʷ ɡ̚ ɡk k̥ː ɡʷː ɡ̥ʷː',
  'ɤ̃ː': 'ʌ̃ː õː ɔ̃ː õ̞ː ɤ̞̃ː',
  'ʛ̥ː': 'qʼː ʛː',
  'ɤ̞ː': 'oː ɤː o̞ː',
  'ɤ̞̃ː': 'ʌ̃ː õː ɔ̃ː õ̞ː ɤ̃ː',
  'ɣ͈ː': 'ɣ͈ʷː',
  'ɡ͈ː': 'ɡ͈ʷː',
  'ɢǀ': 'ɴǀɢ',
  'ɡǀkʰ': 'ɡǀqʰ',
  'ɢǀqʰ': 'ɴɢǀqʰ',
  'ɡǀqʰ': 'ɡǀkʰ',
  'ɢǁ': 'ɴǁɢ',
  'ɡǁkʰ': 'ɡǁqʰ',
  'ɢǁqʰ': 'ɴɢǁqʰ',
  'ɡǁqʰ': 'ɡǁkʰ',
  'ɢǂ': 'ɴǂɢ',
  'ɡǂkʰ': 'ɡǂqʰ',
  'ɡǂqʰ': 'ɡǂkʰ',
  'ɠɓ': 'ɓʷ ɡb',
  'ɡb': 'ŋmɡb ɡbʲ kp ɡbʷ ɓ kpʰ db ɓʷ ŋm ɡbⁿ ŋɡb ɠɓ ɣβ ɟb ɡ ɣ k ŋmɡbʷ',
  'ɡbʲ': 'ɡb ŋmɡb ɡbʷ',
  'ɡbⁿ': 'ɡb',
  'ɡbʷ': 'ɡb ɡbʲ ŋmɡb ŋmɡbʷ',
  'ɤe': 'ɪː iː eː',
  'ɡɣ': 'ɡ ɣ ɡʲ ɟ',
  'ɡˠ': 'ɡ ŋ',
  'ɡʱ': 'ɡ ɣ ɡʷ ɡ̃ ɡ̠ ɡ̟ ɡ̤',
  'ɢʲ': 'ɢ',
  'ɣʲ': 'ɣ ɣʷ ɡʲ ɡ ʁ k q ʷɣ ɣʷʲ',
  'ɡj': 'ɟ ɡɟ ɡ',
  'ɡʲ': 'ɡ ɡʷ ɣ ɟ k ɡʷʲ j ɡɣ ɡʷˠ ʁ ɣʲ ɰ ʕ ɡⁿ ɠ ɡ̥ʲ kʲʰ kʲ ŋɡʲ ŋɡ ʷɡ ʝ ŋ dʲ',
  'ɡɟ': 'ɟ ɡj ɡ',
  'ɡ̟ʲ': 'ɡ d̠ʒʲ',
  'ɡ̥ʲ': 'ɡʲ ɡ k kʲʰ',
  'ɡk': 'ɡ ɡ̚ ɣ ɡː',
  'ɡˡ': 'ɡ ɡⁿ ɡ̊',
  'ɤɰ': 'ɤ',
  'ɡⁿ': 'ɡ ɡ̚ k͉ ɡʷ ɡʲ ɡˡ ɡ̊',
  'ɡŋ': 'ŋ ɡ ŋɡ ɲ n dn',
  'ɢʁ': 'ɢ ʁ',
  'ɤu': 'o ou',
  'ɣua': 'ua',
  'ɣue': 'ue',
  'ɡv': 'ɡ ɡʷ',
  'ɣʷ': 'ɣ w ɡ ɣ̃ʷ ɡʷ kʷ ʝ ɣʲ βˠ x ʔw ɰʷ ɟ k v',
  'ɡw': 'ɡ ŋɡ',
  'ɡʷ': 'ɡ ɡʲ kʷ w ɣ ŋɡ ɟ ɣʷ kʷː ɡʷː ɰ ɡʷʲ ɡⁿ ɡ̚ ɠ kʷʼ ɡ̥ʷ kʷʰ ɡʱ ɡ̃ ɡː ɡ̠ ŋɡʷ k ɡv ʝ',
  'ɣ̃ʷ': 'ɣʷ w',
  'ɡ̥ʷ': 'ɡʷ kʷ kʷʰ',
  'ɡʷː': 'ɡʷ ɡː ɡ̥ʷː',
  'ɡ̥ʷː': 'ɡʷː ɡː',
  'ɣ͈ʷː': 'ɣ͈ː',
  'ɡ͈ʷː': 'ɡ͈ː',
  'ɡʷˠ': 'ɡʲ ɡ',
  'ɣʷʲ': 'ɣ ʷɣ ɣʲ',
  'ɡʷʲ': 'ɡ ɡʲ ɰ ɡʷ ʷɡ',
  'ɣx': 'ɡ ɣ ʁ q q̚ ɡx',
  'ɡx': 'ɡ ɣ ʁ q q̚ ɣx',
  'ɢʘ': 'ɴʘɢ',
  'ɡʘkʰ': 'ɡʘqʰ',
  'ɡʘqʰ': 'ɡʘkʰ',
  'ɣβ': 'ɡb',
  'h': 'x ɦ hʷ s ç k ɣ h̃ χ ʔ ɸ hʲ ʃ ŋ ŋk ʍ n̥ f ɡ ∅ ɦ̃ x̟ m̥ h̃ʲ ɸː p ɬ w ts kʰ l b xː ʃː hː ŋ̥ ɲ̟̥ h͉ sʲ fː hˤ ø xw t̠ʃ ch ʒ k̚ xʲ ʍʲ ⁿh xʷ tʰ t θ ð ʰsʰ ɹ ɾ h̬ çː r l̥',
  'ʜ': 'ʕ ʕ̥',
  'h̃': 'h ɦ h̃ʲ hʷ',
  'ħ': 'ħʷ ħ̃ x',
  'ħ̃': 'ħ',
  'ɦ': 'h x ç ʔ h̃ ɣ hʲ ɦʲ ɦˠ ɦʷˠ ɦ̃ sʲ s xw k ɡ ɦ̥ ɰ ∅',
  'ɦ̃': 'h x ɦ',
  'h͉': 'h',
  'h̬': 'h',
  'ɥ': 'w w̃ j u y ʋ ɰ ʝʷ o̞̯ nʷ ɥ̥ ŋʷ β̞ ɥ̃ ʕ ŋ ŋw̃',
  'hˤ': 'h',
  'ɥ̃': 'w̃ w ɥ',
  'ɦ̥': 'ɦ x',
  'ɥ̥': 'ɥ',
  'hː': 'h',
  'ʜː': 'ʕː ʕ̥ː',
  'ɥː': 'uː',
  'ɦˠ': 'ɦ ɦʲ ɦʷˠ',
  'ɥie': 'uie',
  'ɥiɛ': 'uiɛ',
  'hʲ': 'h hʷ ʃ ɦ xʲ h̃ʲ ɸ ç ɸː fː f b',
  'ʰj': 'j ç',
  'h̃ʲ': 'h hʷ h̃ hʲ',
  'ɦʲ': 'ɦ ɦˠ ɦʷˠ',
  'hk': 'ʰk k̥ çk',
  'ʰk': 'k kʰ xk kʔ ʔk ɡ̰ k̃ hk k̥ çk',
  'ʰkˑ': 'ʰk̟ː ʰkː k̟ʰ kʰ',
  'ʰkː': 'ʰk̟ː ʰkˑ k̟ʰ kʰ',
  'ʰk̟ː': 'ʰkː ʰkˑ k̟ʰ kʰ',
  'ʰkʰ': 'k kʰ',
  'hl': 'l̥',
  'ʱl̥': 'l̥',
  'hm': 'm̥',
  'ʱm̥': 'm̥ m̥b m̥̩',
  'hn': 'n̥',
  'ʱn̥': 'n̥ n̥d n̥̩',
  'ʱɲ̊': 'ɲ̊ ɲ̊dʑ ɲ̩̊',
  'hŋ': 'ŋ̥',
  'ʱŋ̊': 'ŋ̊ ŋ̊ɡ ŋ̩̊',
  'hp': 'ʰp p̥ çp',
  'ʰp': 'p pʰ pʔ ʔp b̰ p̃ hp p̥ çp',
  'ʰpˑ': 'pʰ ʰpː',
  'hpː': 'ʰpː',
  'ʰpː': 'pʰ ʰpˑ hpː',
  'ʰpʰ': 'p pʰ',
  'ʰq': 'q',
  'hr': 'r̥',
  'ʰs': 's',
  'ʰsʰ': 'tʰ t ts θ ð h ɹ ɾ ʔ',
  'ht': 'ʰt t̥ çt',
  'ʰt': 't st tʰ θt ht t̥ çt',
  'ʰtˑ': 'tʰ ʰtː',
  'htː': 'ʰtː',
  'ʰtː': 'tʰ ʰtˑ htː',
  'ʰtːs': 'ʰtsː',
  'htːʃ': 'ʰt̠ʃː',
  'ʰtʰ': 't tʰ',
  'hts': 'ʰts t̥s çts',
  'ʰts': 'ts tsʰ ʰtsː stsː sts hts t̥s çts',
  'ht̠ʃ': 'ʰt̠ʃ t̥ʃ çt̠ʃ',
  'ʰt̠ʃ': 't̠ʃ t̠ʃʰ st̠ʃ ʃt̠ʃ ht̠ʃ t̥ʃ çt̠ʃ',
  'ʰtsː': 'tsʰ stsː sts ʰts ts ʰtːs',
  'ʰt̠ʃː': 'htːʃ',
  'hw': 'f p',
  'hʷ': 'h xʷ hʲ h̃ʷ h̃ʲ h̃ k kʷ l x b',
  'h̃ʷ': 'hʷ',
  'ħʷ': 'ħ',
  'ɦʷˠ': 'ɦ ɦʲ ɦˠ',
  'i': 'ɪ ĩ iː e i̥ ɨ j ə ɛ ĭ ḭ u y iˑ ɯ ɪ̃ ɪ̈ ii̯ i̠ ʉ ĭ̥ i˞ ɪ̥ ʏ ei ɪə ɨː a ʊ iə ɨ̃ eː ɪi ɘ ai ɪ̆ ɨ̟ ɪː iˤ jɪ ɨ̥ i̯ i̞ ĩː ɛː ɲ ∅ iʔ ɻ̩ s̞̩ ɻ̥̩ z̞̩ ɪə̯ ɤ̞ e̞ ɪ˞ ə̴ ɪ̃̈ ɤ ɛi ɛa ɛ̆ eɛ̯ iə̯ ɪ̰ ḛ ia̯ ɵ̠̞ ə̠ ə̟ ɰɨ ɨ̠ ɪ̥̆ i̥ː uː iʲ ɨʲ ɔ iʌ ʲi jə ɐ ̯i̯ e̯ iᵊ i͓ ĭ̃ c k ç ʝ ʝi ʔi ɯ̽',
  'ɪ': 'i e ɪ̃ ɛ iː ə ɨ ĩ ɪ̠ j ɪ̈ e̞ ɪ̥ ɪː ʊ ɤ ʏ i˞ i̥ ɯ ɪ̆ ḭ u y ɪ̃̈ ɪ̰ ɪə ɪ̥̆ ɨ̟ ɪ̤ ɪ̯ e̯ɪ e̝ jɪ ɨ̃ æ ɪi oɤ o ɪ˞ e˞ ʉ ɵ ɒ ei ɛ̆ eɛ̯ ă ə̯ɪ ĭ ɪ̰ː j̥ j̃ ḛ ii̯ ɪɪ̠̯ ia̯ ɘ ɰɨ ɨ̠ ɨː uː iʌ eː jə ̯i̯ i̯ iə ẽ i͓ i̞ ʊ̜ ɛː i̠',
  'ɪ̈': 'ɪ i ɨ ɘ e ɐ ə ɪi ɛ e˞ ʏ ɯ ɪ̃̈ iː ɤ ɨː ɨ̆ ɪ̆̈ ii̯ ɪ̠ ɪ̃ ɰɨ ɨ̟ ɨ̠ ɨ̃',
  'ĭ': 'i ɪ̆ ĭ̥ iː i̥ j ɤ̞ ɘ ɪ y ɯ̆ a ĩ ĭ̃',
  'ɪ̆': 'ĭ ɪ i iː e ɪ̥̆',
  'ĩ': 'i ɪ ɪ̃ iː i̥ j ɨ ĭ̃ ḭ ḭ̃ i̠ n̩ ŋ̩ ɲ̩ iˑ iə e ĩˤ ɛ i̯ ɨ̟ i͓ i̞ ĭ ə ỹ ĩː ɲ ĩi̯ ∅ ʔi ŋ ɴ ẽ',
  'ɪ̃': 'ɪ ĩ i j ɛ ɪ̥ ɪ˞ ɪ̠ ɪ̈ ɪː',
  'ɨ': 'i ɨ̃ ə ɪ u ɨː ɨ̥ ʊ e ɪ̈ iː ʉ ɯ j i̥ ĩ z̞̩ ə̃ ɨ̰ ɨ̯ ɪ̠ uː o ɛ ɐ ɨ̆ ɪ̆̈ ɪɪ̠̯ i̠ ɰɨ ɨ̟ ɨ̠ ɨˑ iʲ ɨʲ iʌ a əː i͓ i̞ ũ u͓ ɵ ʏ ii̯ ∅ ɨ̃ː',
  'ɪ̆̈': 'ɪ̈ ɨː ɨ̆ ɨ',
  'ɪ̃̈': 'ɪ ʏ i ɯ iː ɪ̈ ɤ',
  'ĭ̃': 'ĩ i ĭ j',
  'ɨ̆': 'ɪ̈ ɨː ɨ ɪ̆̈',
  'ɨ̃': 'ɨ i ɨː ɨ̰ ɨ̥ ɪ ɪ̈ ɨˑ ã ə̃ u iː ũ ɨ̃ː',
  'i̘': 'ĩ̘',
  'i̙': 'ĩ̙',
  'ɪ̙': 'ɪ̠̙ e̙',
  'i̞': 'i ĩ ɨ i͓ ɪ iː i̤ i̠',
  'i̠': 'i ɨ ĩ i̥ i̞ ɪ',
  'ɪ̠': 'ɪ ɨ ɪɪ̠̯ ɪ̈ ɪ̃ ɘ',
  'i̤': 'ĭ̤ i̞ i̤i̯',
  'ɪ̤': 'ɪ e',
  'i̥': 'i ĩ ɨ ɪ ḭ iˑ ĭ ɲ ɻ̩ s̞̩ ɻ̥̩ z̞̩ y ə̴ e iə̯ ii̯ i̠ ɪ̥ iː ɨ̥ c k ç ʝ',
  'ɪ̥': 'ɪ i ɪ̃ i˞ e i̥',
  'i̯': 'i e e̯ ɛ eː ɪ ĩ ɨ̟',
  'ɪ̯': 'j ɪ ɪ̥̯ e̯',
  'ḭ': 'i i̥ ɪ ĩ iə̯ ɪ̰ e ḛ iʔ',
  'ɪ̰': 'ɪ ɪ̰ː ɪː i ḭ e ḛ',
  'ĩ̘': 'i̘',
  'ĩ̙': 'i̙',
  'ɪ̥̈': 'ɨ̥',
  'ĭ̤': 'i̤',
  'ĭ̥': 'i ĭ ɤ̞ ɘ y',
  'ɪ̥̆': 'ɪ ɪ̆ i',
  'ɨ̟': 'ɪ i ɰɨ ɪ̈ ɨ̠ ɨ ĩ i̯',
  'ɨ̠': 'ɪ ɰɨ i ɪ̈ ɨ̟ ɨ',
  'ɨ̥': 'ɨ ɨ̃ i ʉ ɨ̰ ɪ̥̈ i̥',
  'ḭ̃': 'ĩ',
  'ɨ̯': 'ɨ',
  'ɨ̰': 'ɨ ɨ̃ ɨ̥ ə̃',
  'iˑ': 'i iː i̥ ĩ ɪˑ',
  'ɪˑ': 'iˑ',
  'i˞': 'ɪ i e̞ ɪ̥',
  'ɪ˞': 'i ɪ̃ ɪ',
  'iˤ': 'i',
  'ɨ̯̃': 'ŋ ʉ̯̃',
  'ĩˤ': 'ĩ',
  'ɨˑ': 'ɨ ɨ̃',
  'ɪ̠̙': 'e̙ ɪ̙',
  'ɨ˞': 'ɨ̥˞ ɨ˞ː',
  'ɪ̥̯': 'ɪ̯',
  'ɨ̥˞': 'ɨ˞ ɨ˞ː',
  '̯i̯': 'i ɪ iː',
  'iː': 'i ɪ ĩː ĩ eː ɪː ɨ ɨː iˑ ḭː ə̯iː ĭ i̠ː uː j ʏ ɯ ɪ̃̈ ɪ̈ ɤ eːi ɪ̆ eːə̯ ɤe iə̯ ɪi i̤ː ii̯ u ʊ iʲ ɨʲ ə ʲiː ɨ̃ ̯i̯ i̥ iˤː y i͓ i̞ əː ɯː ɛ ɛː ei aɪ ʔi',
  'ɪː': 'iː ɪ eː i ɛː ə̴ː ɪ̰ː ɪ̰ ɪ̠ː ɤe ɪ̃ː i̠ː ɪ̃ ʊ̜ː ɛ ɜː ɔː øː',
  'ĩː': 'iː i ĩ',
  'ɪ̃ː': 'ɪː',
  'ɨː': 'ɨ iː i ɨ̃ ɨ̃ː ɪ̈ ɨ̆ ɪ̆̈ ɪ u ʊ uː iʲ ɨʲ',
  'ɨ̃ː': 'ɨː ɨ ɨ̃',
  'i̙ː': 'i̠̙ː',
  'i̠ː': 'iː ɪː',
  'ɪ̠ː': 'ɪː',
  'i̤ː': 'iː',
  'i̥ː': 'i',
  'ḭː': 'iː eːə̯',
  'ɪ̰ː': 'ɪ ɪː ɪ̰',
  'iˤː': 'iː',
  'i̠̙ː': 'i̙ː',
  'ɨ˞ː': 'ɨ˞ ɨ̥˞',
  'ɪːɒ̯': 'ʌˤː',
  'ia': 'ɛ iæ iɛ iɘ ɘ',
  'ia̯': 'i ɪ',
  'iɑ': 'ĭɑ',
  'ĭɑ': 'iɑ',
  'iæ': 'ɛ iɛ ia iɘ ɘ',
  'ie': 'e ɛ eː',
  'ie̞': 'e̞ iɛ',
  'iə': 'i ĩ ɪ ɪə',
  'iᵊ': 'i',
  'ɪə': 'i ɪ iə eː eɪ',
  'iɘ': 'ɛ iæ iɛ ia ɘ',
  'iə̯': 'i ḭ i̥ iː',
  'ɪə̯': 'i e',
  'iɛ': 'ɛ iæ ia iɘ ɘ ie̞ e̞',
  'ɪi': 'i ɪ ɪ̈ iː',
  'ii̯': 'i i̥ ɪ ɪ̈ iː ɨ',
  'ɪɪ̠̯': 'ɪ̠ ɪ ɨ',
  'ĩi̯': 'ĩ',
  'i̤i̯': 'i̤',
  'iʲ': 'ɨʲ iː ɨː i ɨ',
  'ɨʲ': 'iʲ iː ɨː i ɨ',
  'io̞': 'o̞ə̯ o̞i o̞ɔ̯ ɵ o̞ uo̞',
  'iʃ': 'ʃ',
  'iu̯': 'i̯u',
  'i̯u': 'iu̯',
  'ḭu': 'ḭṵ̆',
  'ḭṵ̆': 'ḭu',
  'iʌ': 'i ɪ ɨ',
  'iʔ': 'i ḭ',
  'j': 'i j̃ j̥ ʝ ɲ d̠ʒ jː ɟ ʒ ɪ ç jʷ ɣ w e̯ z c ĩ ɪ̯ j͉ ɨ j̰ ɟʝ zʲ ɥ dʲ ɡ θ ɯ sʲ ɪ̃ ɛ nʲ ĭ k iː ə ʃ ɡʲ β̞ ∅ e ɛ̯ j̰̃ l e̞̯ n̠d̠ʒ z̻ ʒ̃ ɣ̟ j̆ ʔʲ d̪ s n ʑj dzj ʔj jʒ ɟʑ jʱ a ñ ʰj t̠ʃ y ĭ̃ ɲj̃ ə̆ ɟ̥ ʎ ɹ ɕ cɕ c̚ cç j̊ e̝ ˀj ɰ ː k͉ jj̥',
  'j̆': 'j',
  'j̃': 'j ɲ n dʲ e̯ ŋ j̰̃ j̰ ç j̥ ɪ ɟ ʒ ʒ̃ nʲ ɾ̃ m ɱ',
  'j̊': 'j',
  'ɟ': 'c ɡ j d̠ʒ ɲ k ʝ ɟʝ dʲ ɡʲ ɲɟ c̚ ɟ̚ d d̪ ɟː ɣ t̠ʃ ɡʷ ɗ l cç ɟ̥ ŋɡ cː r ɡ̤̥ c̤ j̃ z̻ ɡ̟ ɟʲ cʰ ɖ z ɡj ɡɟ ʲdn ʲn ɟʑ ŋɡʲ ɗʲ ɡɣ ɟʷ ɬ t ð ʄ ɣʷ ʔ ɕ ç cɕ k̬ kʰː d̟ʑ̟',
  'jˀ': 'dˀ tˀ',
  'ʄ': 'f d̠ʒ ʒ p ɗ ɗʒ ɟ ɟ̚',
  'j̥': 'j j͉ ʝ ç ɟʝ j̰ ɪ j̃',
  'j͉': 'j j̥',
  'j̰': 'j j̃ j̰̃ ˀj̥ j̥ dj jʔ',
  'ɟ̚': 'ɟ ʝ c ʄ',
  'ɟ̟': 'c̟ d̠ʒ c̟ʰ ɟ̟̚',
  'ɟ̠': 'c̠',
  'ɟ̥': 'ɟ c j',
  'j̰̃': 'j j̃ j̰',
  'ʝ': 'j ɣ ɟʝ ɟ d̠ʒ ç e̯ j̥ z ɣʷ ɣ̟ ɟ̚ c ɡ ɡʷ ɡʲ x ɰ ɣː i i̥ ɲ ɾʲ ɹ',
  'ɟ̰': 'cʼ ɡ̰ kʼ',
  'ʝ̃': 'ɲ',
  'ɟ̚ˀ': 'd̠ʒ',
  'ɟ̟̚': 'd̠ʒ ɟ̟',
  'ɟ̰̩': 't̠ʃ ʲd̚ ʲt̚',
  'ˀj': 'j',
  'ˀj̥': 'j̰',
  'ˀj̰': 'ʔɲ̰',
  'jː': 'j j̃ː jj̥ː',
  'j̃ː': 'jː',
  'ɟː': 'ɟ c cː',
  'ʝː': 'ʎː',
  'ja': 'a wa jwa ɔ',
  'ɟb': 'ɡb',
  'ʲç': 's ʲh',
  'ʲd̚': 'ɟ̰̩ t̠ʃ ʲt̚',
  'ʲdn': 'ɟ ʲn',
  'ʲɖɳ': 'ɖɳ dɳʷ',
  'ʲe': 'e',
  'jə': 'ə wə jwə i ɪ jɪ',
  'ʲeː': 'eː',
  'ʲh': 'ç s ʲç',
  'jʱ': 'j',
  'jɥ': 'jʷ',
  'jɪ': 'i ɪ ə jə',
  'ʲi': 'i',
  'ʝi': 'i',
  'ʲiː': 'iː',
  'jj̥': 'j',
  'ɟʲ': 'ɟ',
  'ɟʝ': 'ʝ cç ɟ j ʃ j̥ ç ʒ d̠ʒ dz z ɲɟʝ ɟ̊ʝ̊',
  'ɟ̊ʝ̊': 'ɟʝ',
  'ɟ̥ʝ': 'cç c',
  'jj̥ː': 'jː',
  'ɟʝʷ': 'cçʷ',
  'ʲɭ': 'ɭ ɭʷ',
  'ʲn': 'ɟ ʲdn',
  'ʲɳ': 'ɳ ɳʷ',
  'ɟɲ': 'ɲ ɲɟ',
  'ʲɻ': 'ɻ ɻʷ',
  'ʲt': 'c ʃ t̠ʃ ts s ʲt̚',
  'ʲt̚': 't̠ʃ c ʃ ts s ʲt ɟ̰̩ ʲd̚',
  'ʲʈ': 'ʈ ʈʷ ɖ',
  'jw': 'ø w',
  'jʷ': 'j ʒʷ jɥ',
  'ɟʷ': 'ɟ',
  'ʝʷ': 'ɥ',
  'jwa': 'a ja wa',
  'jwə': 'ə jə wə',
  'ɟʑ': 'j ɟ',
  'jʒ': 'j',
  'ɟʒ': 'd t dʲ',
  'jʔ': 'j̰ dj',
  'k': 'ɡ kʰ k̚ kʷ kʲ ɣ ʔ x q c k̟ kː h kx χ t̠ʃ ŋk ʁ k̠ ɟ kⁿ k̟ʰ ʰk kʲʰ qʰ qχ ɡ̚ ɰ k̟̚ ŋɡ kf d̠ʒ kp ɡʲ ɡ̟ k͉ k̟ʲ kˀ q̚ kʰː kˑ ˀk kʼ kˤ kʷʲ ŋ qʷ j p ɡ̰ ç ɡ̥ k̃ ʔk k̬ k̚ʷ kp̚ ʔʷ t kɣʷ kɣ cʝ k͈̚ k͈ k̟ː kʷˠ ɢ qχʰ kw ʕ hʷ kh kŋ ŋ̚ ʀ ɦ s ɡ̥ʲ ɣʲ d k̠ʰ k̰ ʰkʰ ɡb ʷk cʰ cç kχ ɡʷ ʔ̚ ɣʷ ɣ̞ ɡ̊ ʃ ʒ kʔ kx̟ kx̟ʰ i i̥ ɲ ʔk̚ ŋʔk̚',
  'k̃': 'kʰ k kʷ kʲ c kʔ ʔk ɡ̰ ʰk',
  'kˀ': 'k kʰ',
  'kʼ': 'kʼː k̚ kʲʼ k ɡ ɣ kʷʼ cʼ ɟ̰ ɡ̰ ɡˀ qʼ ʔ q k̟ʼ k̠ʼ',
  'k̚': 'k kʰ ɡ ɣ x kʷ kⁿ ʔ q k̟ q̚ k̟ʰ kʼ ɡ̚ k̟̚ cʰ kʲ ɰ ʁ kː k̚ʷ kp̚ ʔʷ k͉ kɣʷ kɣ cʝ qʰ kˑ ɡː ˀk kʷʲ h ɡ̰ ŋ̚ χ qʷ kx cç ɡ̊ kˡ kp',
  'k̟': 'k kʰ k̟ʰ k̟̚ ɡ k̚ c k̠ ɡ̟ ɡ̟͈ k̟ʲ kʷ q q̚ qʰ kˑ kː k̟ː kp',
  'k̠': 'k k̟ kʰ k̠ʰ kʷʰ',
  'k̥': 'ʰk hk çk',
  'k͉': 'ɡ k͉̚ k k̚ ɡ͉ ɡⁿ ɡ̚ ɣ j',
  'k̬': 'k ɡ kʰː c ɟ',
  'k̰': 'k̰ʲ k ɡ',
  'k͈': 'k͈̚ ɡ k',
  'kˑ': 'k kː k̚ ɡ k̟ː k̟ ɡ̟',
  'kˤ': 'k kʷˤ',
  'k̟ʼ': 'kʼ k̠ʼ',
  'k̠ʼ': 'kʼ k̟ʼ',
  'k̟̚': 'k̟ k̟ʰ k kʰ k̚ k̟ʲ kʷ q q̚ qʰ',
  'k͉̚': 'k͉ ɡ',
  'k̟͉': 'ɡ̟',
  'k͈̚': 'k͈ ɡ k',
  'ˀk': 'k c kː kⁿ kʰ k̚',
  'ˀk͉': 'ɡ',
  'kǃʰ': 'qǃʰ',
  'kː': 'k ɡ kʰ kˑ k̚ ɡː kˤː ˀk k̟ː k̟ ɡ̟ qχʰː k̟ʲː kʷ kʰː kʲ kʷː',
  'kʼː': 'kʼ kʷʼ',
  'k̟ː': 'ɡ kˑ kː k k̟ ɡ̟',
  'k̥ː': 'ɡː',
  'k͈ː': 'k͈ʷː k͈ʲː',
  'kˤː': 'kː',
  'kǀʰ': 'qǀʰ',
  'kǁʰ': 'qǁʰ',
  'kǂʰ': 'qǂʰ',
  'kcʰ': 'kʰː',
  'kf': 'k ɡ kʰ kʷ',
  'kɣ': 'kɣʷ cʝ k k̚',
  'kɣʷ': 'kɣ cʝ k k̚',
  'kh': 'k',
  'kʰ': 'k k̚ ɡ kʲ kʷ x k̟ʰ kx k̟ cʰ χ kʲʰ qʰ q ɣ k̟̚ kⁿ k̠ c kː kʷʰ cç ʰk ŋkʰ ʔ h k̠ʰ k̃ kˡ kʔ ʔk k̬ʰ c̬ʰ k̟ʲʰ qχ kxʷ q̚ kʰː kˀ kxʰ ʰk̟ː ʰkː ʰkˑ ˀk kʷˠʰ qχʰ ɰ kʷʲ ʁ w tʰ pʰ kŋ t̠ʃʰ ʰkʰ ɡ̥ kχ kf ç ɡ̰ kx̟ kx̟ʰ k̚ʰ ɡ̤',
  'k̚ʰ': 'kʰ',
  'k̟ʰ': 'kʰ k k̟ k̟̚ k̚ kʷʰ k̟ʲʰ q q̚ qʰ ʰk̟ː ʰkː ʰkˑ k̠ʰ',
  'k̠ʰ': 'kʰ k̟ʰ k k̠',
  'k̬ʰ': 'kʰ cʰ c̬ʰ',
  'kʰː': 'k kʰ kcʰ kː k̬ ɡ c ɟ',
  'kʲ': 'k kʷ kʰ ɡ c kʲʰ q k̚ kʷʲ ʔ ŋɡʲ kʷˠ qχʰ ŋk ɰ kⁿ x k̃ ɡʲ ŋkʰ ʷk kxʲ kː tʲ',
  'kʲʼ': 'kʼ kʷʼ',
  'k̟ʲ': 'k k̟ kʷ k̟̚',
  'k̟ʲʼ': 't̠ʃʲʼ',
  'k̰ʲ': 'k̰',
  'k̟ʲː': 'kː',
  'k͈ʲː': 'k͈ː k͈ʷː',
  'kʲʰ': 'kʰ k kʲ kʷˠʰ ɡʲ ɡ ɡ̥ʲ',
  'k̟ʲʰ': 't̠ʃʲ k̟x̟ʲ kʷʰ kʰ k̟ʰ',
  'kˡ': 'kʰ k̚ kⁿ',
  'kɬʼ': 'tɬʼ',
  'kʟ͓̥ʼ': 'kxʼ',
  'kⁿ': 'k k̚ x kʰ ˀk kʷ kʲ ɡ ɣ kˡ',
  'kŋ': 'kʰ k kʷ kŋʷ',
  'kŋʷ': 'kŋ',
  'kp': 'kpʰ kpʷ ɡb kpʲ k tp kpⁿ p kp̚ ŋmkp cp ɡ kʷ ƥ k̚ k̟',
  'kp̚': 'k̚ʷ k̚ k kp',
  'kpʰ': 'kp ɡb',
  'kpʲ': 'kp kpʷ ŋmkp',
  'kpⁿ': 'kp',
  'kpʷ': 'kp kpʲ',
  'kw': 'k',
  'kʷ': 'k kʲ kʰ ɡʷ ɡ k̚ kʷʰ c kʷː qʷ ʔ ɣʷ k̟ k̟ʲ k̟̚ ŋkʷ ŋk ɰ kʷʲ kⁿ hʷ kŋ q q̚ ʁ χ k̚ʷ ɡ̥ʷ k̃ ŋkʰ kː kp kf',
  'kʷʼ': 'kʼ ɡʷ kʲʼ kʼː kʷʼː',
  'kʷˤ': 'kˤ',
  'k̚ʷ': 'kp̚ k̚ k kʷ kʷʰ',
  'kʷː': 'kʷ ɡʷ kː',
  'kʷʼː': 'kʷʼ',
  'k͈ʷː': 'k͈ː k͈ʲː',
  'kʷˠ': 'kʲ k',
  'kʷˠʰ': 'kʰ kʲʰ',
  'kʷʰ': 'kʷ kxʷ kʰ k̟ʲʰ k̟ʰ k̚ʷ ɡʷ ɡ̥ʷ k̠',
  'kʷʲ': 'k kʲ kʰ ɰ k̚ kʷ ʷk',
  'kx': 'k kʰ x qχ χ q cç ɡ ʔ qʰ kxʷ k̚ cʰ ʔ̚ ç kʔ ʔk',
  'kxʼ': 'kʟ͓̥ʼ',
  'kx̟': 'k kʰ kx̟ʰ',
  'kxʰ': 'kʰ',
  'kx̟ʰ': 'k kʰ kx̟',
  'kxʲ': 'kʲ',
  'k̟x̟ʲ': 'k̟ʲʰ t̠ʃʲ',
  'kxʷ': 'kʷʰ cç kx kʰ',
  'kʔ': 'kʰ ʔk kx ʔ k ɡ̰ k̃ ʰk',
  'kʘʰ': 'qʘʰ',
  'kχ': 'k q χ kʰ',
  'l': 'r ɾ d n lʲ l̥ lː ʎ ɭ lˠ l̪ l̩ lʷ l̃ ɺ ɫ ɬ ɹ t ɽ ɾ̃ ɗ ɻ dl l̰ lʷˠ d̪ ˀl ɾl l̩ˠ lˑ lˤ l̟ ɟ nd ŋ n̪ m ɲ h lɪ̯ ∅ l̥ˠ j ɽ̥ ɺ̥ ɽ̃ nt l̩ʷˠ l̩ʲ l̪ˠ ʎ̟ d̃ dʱ z ʔl lʱ l̻ ɬ̪ lj hʷ tʰ nl ɖ l̚ c r̃ ɹ̚ lʰ ʊ ɯ ʋ ɾ̩ r̩ ll̥',
  'l̃': 'l n r l̥ ɻ ɺ ɾ ɾ̃ lʷ lʲ',
  'l̚': 'l',
  'l̟': 'l ɫ l̪ lʲ',
  'l̠': 'd̠ d̠͓ ɾ d̠ʲ',
  'ɭ': 'l l̪ ɺ lˠ l̩ ɭ̥ ɾ ʎ d ɭʲ ɭ̩ ɬ ɽ̥ ɽ ɺ̥ ɽ̃ l̩ˠ l̥ l̪ˠ lʷ r d̪ t t̚ ɖ d̪θ̪ ɖθ̜ l̪ɬ̪ ɭɬ̜ ʲɭ ɭʷ',
  'l̥': 'l ɫ r ɻ l̃ lː dl l̥ʲ l̥ˑ ɭ l̩ˠ lˠ l̪ˠ l̥ʷ hl l̪ ʎ̥ ɾ ʊ l̩ ʱl̥ ʃ h ʃː n̥',
  'l̩': 'l lˠ ɭ a ə æ l̪ ɫ ʊ l̥ ɾ',
  'l̪': 'l ɭ l̪ʲ ʎ̟ l̪ː l̪̥ r lʲ d l̻ ɽ ʎ ɫ̪ l̥ l̩ n l̪̚ l̪̩ ɫ ɹ ɹ̃ d̪ t t̚ ɖ d̪θ̪ ɖθ̜ l̪ɬ̪ ɭɬ̜ l̪ʷ l̟',
  'l̰': 'l',
  'l̻': 'l̻̥ l̪ l̻ʲ l',
  'ɫ̪': 'l̪',
  'ɬ': 'l tɬ ɬʲ h r ɾ ɭ ɺ ɬ̩ sɬ tɬʼ tɮ ʎʲ dl ɬ̪ ʷɬ ɬʷʲ t d c ɟ',
  'ɮ': 'dl lʲ ɮ̪ ʷɮ ɮʲ ɮʷʲ',
  'lˑ': 'l lː',
  'lˤ': 'l l̩ˤ',
  'l̪̚': 'l̪ l̪̩',
  'ɭ̥': 'ɭ',
  'ɭ̩': 'ɭ',
  'l̪̥': 'l̪ n',
  'l̪̩': 'l̪ l̪̚',
  'ɬʼ': 'tɬʼ',
  'l̻̥': 'l̻ l̻ʲ',
  'l̻̰': 'ˀl̻̥',
  'ɬ̩': 'ɬ',
  'ɬ̪': 'l ɬ',
  'ɮ̪': 'ɮ',
  'l̥ˑ': 'l̥',
  'l̩ˤ': 'lˤ',
  'ˀl': 'l',
  'ˀl̻̥': 'l̻̰',
  'lː': 'l l̥ dl lˑ lʲ lˠ r ʎ lʎ ll̥ː',
  'l̪ː': 'l̪',
  'lˠ': 'l l̥ˠ l̩ lʲ ɭ l̪ˠ lʷˠ l̩ˠ l̥ lː ʎ l̪̥ˠ',
  'l̥ˠ': 'lˠ l',
  'l̩ˠ': 'l ɭ lˠ l̥ l̪ˠ',
  'l̪ˠ': 'lˠ l̪̥ˠ ɭ l̩ˠ l̥ l',
  'l̪̥ˠ': 'l̪ˠ lˠ',
  'lʰ': 'l ɾ',
  'lʱ': 'l ɫ',
  'lɥ': 'lʷ',
  'lɪ̯': 'l ɫ',
  'lj': 'l',
  'lʲ': 'l lʷ l̥ʲ lˠ ɾ l̪ d lʷˠ lʲː lː ɫ l̃ ɮ r dʲ lʷʲ ʎ l̟',
  'l̠ʲ': 'l̠̥ʲ',
  'ɭʲ': 'ɭ',
  'l̥ʲ': 'lʲ ʎ l̥',
  'l̩ʲ': 'l l̩ʷˠ',
  'l̪ʲ': 'l̪',
  'l̻ʲ': 'l̻ l̻̥',
  'ɬʲ': 'ɬ tɬ ʷɬ ɬʷʲ',
  'ɬʲʼ': 'tɬʲʼ',
  'ɮʲ': 'ɮ ʷɮ ɮʷʲ',
  'l̠̥ʲ': 'l̠ʲ',
  'lʲː': 'lʲ',
  'll̥': 'l',
  'ɭɬ̜': 'd d̪ l̪ t t̚ ɖ ɭ d̪θ̪ ɖθ̜ l̪ɬ̪',
  'l̪ɬ̪': 'd d̪ l̪ t t̚ ɖ ɭ d̪θ̪ ɖθ̜ ɭɬ̜',
  'll̥ː': 'lː',
  'lʷ': 'l lʲ ɾ l̃ ɭ nl r lɥ ɹ̚ dʷ d',
  'ɭʷ': 'ɭ ʲɭ',
  'l̥ʷ': 'l̥',
  'l̪ʷ': 'l̪',
  'lʷˠ': 'l lˠ lʲ',
  'l̩ʷˠ': 'l l̩ʲ',
  'lʷʲ': 'lʲ',
  'ɬʷʲ': 'ɬ ʷɬ ɬʲ',
  'ɮʷʲ': 'ɮ ʷɮ ɮʲ',
  'lʎ': 'lː',
  'm': 'ŋ n ɲ ɱ mʷ m̩ mʲ m̥ mː mb b bm w w̃ n̪ ŋm m̚ m̰ ɓ mˠ ˀm mˑ β̞̃ mʷˠ ɱv ʔm ɴ ɾ l mm̥ mbʷ mbʲ m̩v mv m͈ m͉ mp β̞ bʲ bʷ m̥ˑ ṽ β mw mbv b̰ b̚ p̚ mʱ m̻ p r u n̪|n b͉ nʲ nʷ nː j̃ m̼',
  'ɯ̯': 'mː mˑ m',
  'ɯ̞̥̆': 'ʌ ɯ̞',
  'm̤': 'β̞̤̃',
  'm̥': 'm ŋ m̩ h n̥ b w̃ m͉ m̰ ɲ̟̥ mˠ mʷˠ m̥ˠ hm ɸ mʷ ʱm̥ m̥b m̥̩',
  'm̩': 'm n̩ m̥ ɱ̩ ŋ̩ ɲ̩ ɱ ɯ̃ mp ũ ŋm̩ n̩ʲ m̩ʲ ŋ̟̩ʲ n m̚ mʷ',
  'm͉': 'm̥ ŋ m',
  'm̰': 'm ˀm̥ m̥',
  'm̻': 'm',
  'm͈': 'm',
  'ɯ': 'u ɤ ɯ̥ i ɯ̃ ɨ ə ɰ ɪ ʉ j ũ u̥ ʊ ɯˑ ɘ ɯː ʏ ɪ̃̈ iː ɪ̈ ɯ̞ ɰə ɤ̞ ɤ̞̥ ɤ̞̆ ɯ̰ u̥ː ɔ uɪ uː ʋ l ɫ ü̜ ɯ̈ ɯi <ɯ> e ɯ̽',
  'ɰ': 'ɣ ɡ w k ɯ ɾ ʔ ʁ̞ f ɸ v β ɰ̥ k̚ ɥ ŋ ɰ̃ kʰ kʷ kʲ kʷʲ ɡʷ ɡʲ ɡʷʲ ʀ ɯ̃ ɯː ɦ ʝ ɣː r ɹ ɰʷ ɣ̞ j ː ∅',
  'mˑ': 'm mː m̥ˑ',
  'ɯ̆': 'v β w ʍ ɸ ĭ',
  'ɯ̃': 'ɯ u ŋ̩ n̩ʲ m̩ m̩ʲ ŋ̟̩ʲ n̩ ɯ̥̃ ɤ̞̃ ɯː ɰ ɯ̃i',
  'ɰ̃': 'ŋ ɰ',
  'ɱ̩': 'm̩ n̩ ŋ̩ n̻̩ ŋm̩ ɲ̩',
  'm̥̩': 'm̥ ʱm̥ m̥b',
  'ɯ̞': 'ʊ ɤ ɯ̞ɰ ɤ̞ ɯ ɯ̞̥̆ ʌ',
  'ɯ̤': 'ɯ̤i',
  'ɯ̥': 'ɯ u ɯˑ ɯː',
  'ɰ̥': 'ɰ f ɸ v β',
  'm̥ˑ': 'mː mˑ m',
  'ɯ̰': 'ɯ',
  'ɯ̞̃': 'ʊ̃',
  'ɯ̽': 'ɯ i',
  'ɯ̥̃': 'ɯ̃',
  'ɯˑ': 'ɯ u ɯː ɯ̥',
  'ˀm': 'm ɓ ˀɓ',
  'ˀm̥': 'm̰',
  'mː': 'm ɱ mˑ m̥ˑ w̃ mʷ mm̥ː',
  'ɯː': 'uː ɯ ɤː ɯ̃ ɰ ɯ̃ː u ɯˑ ɯ̥ iː',
  'ɯ̃ː': 'ɯː',
  'ɯ̞̃ː': 'ʊ̃ː',
  'mb': 'b m mbʷ mbʲ bm p mp ɓ bʷ bʲ β p̚ mˀ mpʰ β̞̃ bw b̃ʷ b̃ βʷ b̰ b̚ u w pʲ mʙ ʔm v',
  'mʙ': 'mb',
  'mɓ': 'ɓ bʷ',
  'mb̤': 'b̤',
  'mʙ̥': 'mp',
  'm̥b': 'm̥ ʱm̥ m̥̩',
  'mbʲ': 'mb mbʷ m',
  'mbv': 'm ɱv',
  'mbʷ': 'mb mbʲ b m bʷ p̚',
  'md': 'd',
  'ɰə': 'ə ɯ',
  'ɱf': 'f',
  'mˠ': 'm mʷˠ m̥ mʲ ɱˠ m̥ˠ',
  'mɡ': 'ɡ',
  'ɱˠ': 'mˠ',
  'm̥ˠ': 'm̥ mˠ',
  'mʱ': 'm',
  'ɯi': 'ɯ',
  'ɰɨ': 'ɪ i ɪ̈ ɨ̟ ɨ̠ ɨ',
  'ɯ̃i': 'ɯ̃',
  'ɯ̤i': 'ɯ̤',
  'mʲ': 'm mʷ bʲ b bʷ mˠ mʷˠ mʲː m̥ʲ',
  'm̥ʲ': 'mʲ',
  'm̩ʲ': 'ɯ̃ ŋ̩ n̩ʲ m̩ ŋ̟̩ʲ n̩',
  'mʲː': 'mʲ',
  'mm̥': 'm',
  'mɰ': 'mʷ',
  'ɯ̞ɰ': 'ɯ̞',
  'mm̥ː': 'mː',
  'mp': 'p mb b m m̩ ɸ mʙ̥ mpʰ',
  'mpʰ': 'pʰ mb pʲ pʷ mp',
  'mv': 'm̩v m',
  'ɱv': 'm v mbv ɱvʷ',
  'm̩v': 'mv m',
  'ɱvʷ': 'ɱv v',
  'mw': 'm',
  'mʷ': 'm mʲ ŋm mː m̥ m̩ ɱ mɰ',
  'ɰʷ': 'ɣʷ w ɰ ɾ',
  'mʷː': 'mʷˤː',
  'mʷˤː': 'mʷː',
  'mʷˠ': 'm mˠ m̥ mʲ',
  'mʔp̚': 'p ʔp̚',
  'n': 'ŋ ɲ m nʲ l n̥ n̪ n̩ nː nʷ nd ɳ ɴ ɱ d ɾ dn r l̃ t nˑ n̚ ɲ̟ j̃ n̰ ŋm z̃ˑ d̪ tʰ ɽ̃ ˀn ɾn ŋ̟ nˠ nʷˠ nʷʲ ʔn s ɾ̃ n̠ nn̥ nɪ̯ n̚ʲ ndʲ n͈ n̥͈ ɾ̥ n̥ː n͉ nˤ z dz ŋː n̪̩ m̩ j d̰ d̚ t̚ t̠ʃ ʒ l̪ l̪̥ ɡŋ nj ɹ n̺ ∅ n̟',
  'ɴ': 'ŋ n ɲ n̪ n̥ m n̟ nʲ ɲ̟ n̰ ŋʲ ĩ ũ ə̃',
  'ñ': 'j d̠ʒ ɲ',
  'nˀ': 't t̚ˀ d nd',
  'ɲ': 'n ŋ m j n̪ j̃ ɲː ɲ̥ ɲ̩ ɟ ɲʷ ɲʲ ɳ nʲ ɱ nː ɟɲ ŋʷ ɴ z̻ d̠ʒ ŋm l ɲᶣ i i̥ ɲɲ̥ ˀɲ n͈ n̥͈ n̥ː dʲ ŋ̟ ɲɟ ʝ̃ ɲ̟ d̪ s nʱ n̩ r ɡŋ ñ ɲ̚ ɺ ɾ r̃ ĩ nʷ ɲ̠ c k n̪ː ç ʝ ɽ̃ n̟',
  'n̚': 'n nʲ nd n̚ʲ n̪',
  'n̟': 'n̪ nʲ ŋ ɴ n ɲ',
  'n̠': 'n ɳ',
  'ɳ': 'n n̪ ŋ ɽ̃ ɲ n̩ ɳ̥ ɳ̩ ɳʲ nd nː nʷ ʲɳ ɳʷ n̠',
  'n̥': 'n ŋ h ɴ n̩ m̥ ɲ̟ n̥ʲ nʲ n͉ n̰ ɲ̟̥ n̥ˑ n̥ʷ ɲ̥j hn n̪ ɸ nʷ ʱn̥ n̥d n̥̩ ʃ ʃː l̥',
  'ɲ̊': 'ʱɲ̊ ɲ̊dʑ ɲ̩̊',
  'n̩': 'n ŋ̩ ŋ m̩ ɲ̩ n̪ ɳ n̥ ɱ̩ ɯ̃ ɽ̃ n̻̩ ŋm̩ ĩ n̩ʲ m̩ʲ ŋ̟̩ʲ ɲ',
  'n̪': 'n ŋ ɲ ɳ m n̪̩ nʲ ɴ n̪ː n̩ nː n̪̥ l n̪ʷ n̟ ɽ̃ n̻ n̪t̪ ʔn n̪ʲ nʱ n̪̚ n̥ ɾ ɹ d̪ n̚ n̺',
  'n͉': 'n̥ n',
  'n̰': 'n n̥ ɴ ŋ',
  'n̺': 'n n̪',
  'n̻': 'n̪ n̻̥',
  'ɳ̆': 'ɽ r',
  'n͈': 'ɲ n̥͈ n',
  'nˑ': 'n z̃ˑ nː',
  'nˤ': 'n',
  'ɲ̚': 'ɲ',
  'ɲ̟': 'ŋ n n̥ ɴ ŋ̟ ɲ̟̥ n̠d̠ʒ ɲ ɲ̩ ɲ̟ː <ɲ̟>',
  'ɲ̠': 'ɲ',
  'ɲ̥': 'ɲ ŋ̥ ɲʷ ɲ̩ ɲɲ̥',
  'ɲ̩': 'ɲ n̩ ŋ̩ m̩ ɱ̩ ŋm̩ ĩ ɲ̟ ɲʷ ɲ̥',
  'n̪̚': 'n̪ n̪̥ n̪ː',
  'ɳ̥': 'ɳ',
  'ɳ̩': 'ɳ',
  'n̥̩': 'n̥ ʱn̥ n̥d',
  'n̪̥': 'n̪ n̪̚ n̪ː',
  'n̪̩': 'n̪ n',
  'n̻̥': 'n̻',
  'n̻̩': 'ɱ̩ n̩ ŋ̩',
  'n̥͈': 'ɲ n͈ n',
  'n̥ˑ': 'n̥',
  'ɲ̟̥': 'ɲ̟ h n̥ m̥',
  'ˀn': 'n ɗ ˀɗ',
  'ˀɲ': 'ɲ',
  'n̪|n': 'ŋ m',
  'ɴǃɢ': 'ɢǃ',
  'nː': 'n ŋ ɲ n̪ n̥ː nˤː z̃ˑ nˑ ɳ n̪ː nʷ ɱ m nn̥ː',
  'ɲː': 'ɲ ɲ̥ː ɲɲ̥ː ŋ',
  'n̥ː': 'nː ŋ ɲ n',
  'n̪ː': 'n̪ n̪̥ n̪̚ nː ɲ ŋ',
  'nˤː': 'nː',
  'ɲ̟ː': 'ɲ̟',
  'ɲ̥ː': 'ɲː ɲɲ̥ː',
  'ɴǀɢ': 'ɢǀ',
  'ɴǁɢ': 'ɢǁ',
  'ɴǂɢ': 'ɢǂ',
  'nd': 'd n nt ndʲ dn ndʷ t ɗ dʷ dʲ ɾ l nʲ n̚ nˀ ɳ ŋ ntʰ ndr ɽ d̰ d̚ t̚ d̪ ɖ tʲ ʔn ndɾ ˀnd',
  'nɗ': 'ɗ ɗʷ',
  'n̥d': 'n̥ ʱn̥ n̥̩',
  'n̪d̪': 'd̪ z',
  'n̪d̪̤': 'd̪̤',
  'ˀnd': 'nd',
  'ndʲ': 'nd ndʷ n ntʲʰ ɲɟʝ',
  'ndr': 'nd',
  'ndɾ': 'nd',
  'ndʷ': 'nd ndʲ d dʷ',
  'ndz': 'dz n̠d̠ʒ nz nts ntsʰ d̠ʒ dzʷ nʒ',
  'ɲ̊dʑ': 'ɲ̊ ʱɲ̊ ɲ̩̊',
  'n̠d̠ʒ': 'd̠ʒ ndz n̠d̠ʒʲ n̠t̠ʃ n̠t̠ʃʰ n̠ʒ dʲ j ɲ̟ nʒ t̠ʃ ɲɟ nz n̠d̠ʒʷ d̠ʒʷ',
  'n̠d̠ʒ̤': 'd̠ʒ̤',
  'n̠d̠ʒʲ': 'n̠d̠ʒ',
  'n̠d̠ʒʷ': 'd̠ʒ n̠d̠ʒ d̠ʒʷ',
  'ɳɖ': 'ɖ ɽ',
  'ɳɖ̤': 'ɖ̤ ɽ̤',
  'ɳɖʐ': 'ɳʈʂ',
  'nˠ': 'n nʷˠ nʲ',
  'nɡ': 'ɡ',
  'n̪ˠ': 'n̪̥ˠ',
  'n̪̥ˠ': 'n̪ˠ',
  'ɴɢǃqʰ': 'ɢǃqʰ',
  'ɴɢǀqʰ': 'ɢǀqʰ',
  'ɴɢǁqʰ': 'ɢǁqʰ',
  'ⁿh': 'h',
  'nʱ': 'n̪ ɲ ŋ',
  'nɥ': 'nʷ',
  'ɲᶣ': 'ɲ ɲʷ',
  'nɪ̯': 'n ɾ',
  'nj': 'n ŋ ɱ',
  'nʲ': 'n ŋ nʷ ɲ n̪ n̚ j nʷʲ n̟ ɴ nd n̥ʲ n̚ʲ n̥ nʷˠ nˠ nʲː j̃ dʲ n̪ʷ m ɱ n̠ʲ n̠̥ʲ',
  'nɟ': 'ŋɡ nz',
  'ɲʲ': 'ɲ',
  'ɲj̃': 'j',
  'ɲɟ': 'ɟ ŋɡ ŋɡʷ ŋ ŋɡ̟ ɟɲ ɲ n̠d̠ʒ',
  'n̚ʲ': 'nʲ n̚ n',
  'n̠ʲ': 'n̠̥ʲ nʲ',
  'ɳʲ': 'ɳ',
  'n̥ʲ': 'nʲ n̥',
  'n̩ʲ': 'ɯ̃ ŋ̩ m̩ m̩ʲ ŋ̟̩ʲ n̩',
  'n̪ʲ': 'n̪',
  'n̻ʲ': 'n̻̥ʲ',
  'ɲ̥j': 'n̥',
  'n̠̥ʲ': 'n̠ʲ nʲ',
  'n̻̥ʲ': 'n̻ʲ',
  'nʲː': 'nʲ',
  'ɲɟʝ': 'ntʲʰ ndʲ ɟʝ',
  'nl': 'l lʷ',
  'nm': 'ŋm',
  'nn̥': 'n',
  'ɲɲ̥': 'ɲ ɲ̥',
  'nn̥ː': 'nː',
  'ɲɲ̥ː': 'ɲː ɲ̥ː',
  'nr': 'r ɾ',
  'ns': 's sʷ sʲ',
  'nt': 't nd d l ɾ r',
  'n̪t̪': 'n̪',
  'ntʰ': 'tʰ nd tʲ',
  'ntʲʰ': 'ɲɟʝ ndʲ',
  'nts': 'ts ndz n̠t̠ʃ t̠ʃ tsʷ',
  'n̠t̠ʃ': 't̠ʃ n̠d̠ʒ nts',
  'ɳʈʂ': 'ɳɖʐ',
  'ntsʰ': 'nz ndz c tsʰ',
  'n̠t̠ʃʰ': 'n̠d̠ʒ n̠ʒ',
  'nʷ': 'n nʲ ŋ nʷʲ w̃ ɥ w nː ɳ n̥ nɥ m ɲ ɱ',
  'ɲʷ': 'ɲ ɲ̥ ɲ̩ ɲᶣ',
  'ɳʷ': 'ɳ ʲɳ',
  'n̥ʷ': 'n̥',
  'n̪ʷ': 'n̪ nʲ',
  'nʷˠ': 'nˠ n nʲ',
  'nʷʲ': 'n nʷ nʲ ȵ',
  'nz': 'ndz z nʒ ntsʰ zʷ zʲ dnz nɟ n̠d̠ʒ',
  'nʒ': 'nz n̠d̠ʒ ndz',
  'n̠ʒ': 'n̠d̠ʒ n̠t̠ʃʰ',
  'nʔt̻̚': 't̻ ʔt̻̚ t̺',
  'ɴʘɢ': 'ɢʘ',
  'n̪θ': 'θ',
  'ȵ': 'nʷʲ',
  'ŋ': 'n ɲ m ŋʷ ŋɡ ɴ n̪ ŋʲ ŋ̩ ɡ ŋ̥ ŋ̟ ŋm ŋː nʲ ɡŋ ɱ n̥ ɳ nː w ɲ̟ n̩ h m̥ ŋ̟ʲ nʷ w̃ ŋ̰ ŋɡʷ k l ɣ ɽ̃ n̟ j̃ ŋɡ̟ ɲɟ ˀŋ̟ ˀŋ n̥ː m͉ n̰ nd ŋˑ ɰ̃ ɰ z dz d ŋk ʌ̃ ŋˠ nʱ ɨ̯̃ ʉ̯̃ ŋw t̠ʃ r dn nj n̪|n ɡˠ ʷŋ ŋʷʲ ɲː ŋw̃ ɥ ŋ̚ n̪ː ɡʲ ĩ ũ ə̃ ŋŋ̥',
  'ŋ̊': 'ʱŋ̊ ŋ̊ɡ ŋ̩̊',
  'ŋˀ': 'ŋɡ ŋɡ̟ ɡ̟ ɡ',
  'ŋ̚': 'ɡ̰ k ɡ̚ k̚ ŋ',
  'ŋ̟': 'ŋ n ŋ̩ ˀŋ̟ ˀŋ ŋʲ ɲ̟ ɲ ŋ̥ ŋm',
  'ŋ̥': 'ŋ ŋ̟̥ h ŋ̟ ŋ̥ˠ ɲ̥ hŋ ŋʷ ŋ̩',
  'ŋ̩': 'ŋ n̩ m̩ ɲ̩ ŋm̩ ɱ̩ ɯ̃ ŋ̟ n̻̩ ĩ n̩ʲ m̩ʲ ŋ̟̩ʲ ŋʷ ŋ̥',
  'ŋ̰': 'ŋ',
  'ŋ̩̊': 'ŋ̊ ʱŋ̊ ŋ̊ɡ',
  'ŋˑ': 'ŋ̥ˑ ŋ̟̥ˑ ŋ̟ˑ ŋ ŋː',
  'ŋ̟̥': 'ŋ̥',
  'ŋ̟ˑ': 'ŋˑ ŋ̥ˑ ŋ̟̥ˑ',
  'ŋ̟̥ˑ': 'ŋˑ ŋ̥ˑ ŋ̟ˑ',
  'ŋ̥ˑ': 'ŋˑ ŋ̟̥ˑ ŋ̟ˑ',
  'ˀŋ': 'ˀŋ̟ ŋ ŋ̟',
  'ˀŋ̟': 'ŋ ˀŋ ŋ̟',
  'ŋː': 'ŋ ŋˑ n ŋŋ̥ː',
  'ŋˠ': 'ŋ',
  'ŋɡ': 'ɡ ŋ ŋɡʷ ŋɡʲ ŋk ɣ k ɡʷ ŋɡ̟ ɲɟ ɡŋ ɟ ŋʷ ŋˀ ɡ̟ ŋm ŋkʰ ɡw nɟ x ɡʲ ˀŋɡ',
  'ŋɡ̟': 'ŋɡ ŋɡʷ ŋ ɲɟ ŋˀ ɡ̟ ɡ',
  'ŋɡ̤': 'ɡ̤',
  'ŋ̊ɡ': 'ŋ̊ ʱŋ̊ ŋ̩̊',
  'ŋ̥ˠ': 'ŋ̥',
  'ˀŋɡ': 'ŋɡ',
  'ŋɡb': 'ɡb',
  'ŋɡʲ': 'ŋɡ ŋɡʷ kʲ ɟ ɡʲ',
  'ŋɡʷ': 'ŋɡ ŋ ŋʷ ŋɡʲ ŋɡ̟ ɲɟ ŋkʷ ɡ ɡʷ',
  'ŋʲ': 'ŋ ŋ̟ ɴ ŋʷ ʷŋ ŋʷʲ',
  'ŋ̟ʲ': 'ŋ',
  'ŋ̟̩ʲ': 'ɯ̃ ŋ̩ n̩ʲ m̩ m̩ʲ n̩',
  'ŋk': 'k ŋɡ h ɡ ŋkʲ ɣ ŋ kʷ kʲ ʔ ŋkp',
  'ŋkʰ': 'kʰ ŋɡ kʲ c kʷ',
  'ŋkʲ': 'ŋk',
  'ŋkp': 'ŋk',
  'ŋkʷ': 'kʷ ŋɡʷ',
  'ŋm': 'ŋ m n ŋmʲ ɲ ŋʷ ŋɡ nm ɡb ŋmʷ mʷ ɱ w ŋ̟',
  'ŋm̩': 'ŋ̩ m̩ ɱ̩ ɲ̩ n̩',
  'ŋmɡb': 'ɡb ŋmkp ɡbʲ ɡbʷ ŋmɡbʷ',
  'ŋmɡbʷ': 'ɡbʷ ɡb ŋmɡb',
  'ŋmʲ': 'ŋm ŋmʷ',
  'ŋmkp': 'ŋmɡb kp kpʲ',
  'ŋmʷ': 'ŋm ŋmʲ',
  'ŋŋ̥': 'ŋ',
  'ŋŋ̥ː': 'ŋː',
  'ŋw': 'ŋ',
  'ŋʷ': 'ŋ w ɲ ŋɡʷ ŋʷː ŋm ŋɡ ɥ w̃ ŋʲ ŋ̥ ŋ̩ u wiy ẅiy',
  'ŋw̃': 'w w̃ ŋ ɥ',
  'ŋʷː': 'ŋʷ',
  'ŋʷʲ': 'ŋ ʷŋ ŋʲ',
  'ŋʔk̚': 'k ʔk̚',
  'o': 'ɔ õ u oː ʊ o̥ o̞ ə ɤ ɔː e ɛ oˑ a ɔ̃ o̰ ʌ ø o̝ w uo ŏ o̤ ɒ œ ou ʊ̥ ɵu ʊ̃ ɵ ɑː ɨ ũ ɑ oʔ o̞u oɤ e̞ ɪ ʊə̯ ʊ̈ ɤu ʊ˞ o̟ u̥ ɔ̴ ɔ̆ ɤ̞ uu̯ ʊ̆ oĭ ʊ̤ ʷo uː ɐ o̯ u̯ æ oj oˤ õː oʊ oi ∅ eː ʔo ɔ̃ː au <o> ö əʊ',
  'ö': 'ü ə̈ u o œ w',
  'ŏ': 'o oː õ w ŭ',
  'õ': 'o ɔ̃ ɔ oː ʊ o̥ õ̞ ũ õː ʌ ʌ̃ ɤ̞̃ ɤ̃ oĭ oˑ ə u ŏ ɤ õi ∅ ɑː eː e ʔo',
  'ɵ': 'ə o u a ʉ ɪ ɒ o̞ə̯ o̞i o̞ɔ̯ o̞ uo̞ io̞ o̯u ɵˑ ɵː ɵ̥ ɛ ə̥ ḁ ʌ ɨ ʏ ʊ əʊ ɤ',
  'ø': 'øː o e ə ɔ ø̥ ɛ ø̃ h x ɑ jw w œ ʏ œ̝ y øˑ',
  'ø̆': 'y̆ ɔ̆',
  'ø̃': 'ø',
  'o̘': 'õ̘',
  'o̙': 'õ̙',
  'o̝': 'o oː ʊ ɔ oj ə w',
  'o̞': 'o ɔ õ̞ o̞̰ o̞̥ ʊ o̞ː u ɔ̆ ɔː ø̞ oo̞ o̞u o̞˞ o̞ˑ ɤ ɤ̞ ŏ̞ o̞̰ː ŭ u̥ ɛ a ə ɵ̞ ua o̟̞ oː ʊː o̞ə̯ o̞i o̞ɔ̯ ɵ uo̞ io̞ o̯',
  'o̟': 'o',
  'o̠': 'ɔ',
  'o̤': 'o ŏ̤ o̤i',
  'o̥': 'o õ u ʊ ɔ ɔː',
  'o̯': 'w u̯ w̃ ɔ̯ o̞ o oː',
  'o̰': 'o ʊ u oʔ',
  'õ̘': 'o̘',
  'õ̙': 'o̙',
  'ŏ̞': 'o̞ ɔː ɔ̆',
  'õ̞': 'o̞ ɔ̃ õ o̞˞ ɔ ʌ̃ ɤ̞̃ ɤ̃ o̞̥ o̞̰ õ̞̰ u',
  'ŏ̤': 'o̤',
  'ɵ̞': 'ə̆ ø̞ o̞ ɵ̞̃',
  'ø̞': 'ə o̞ œ ɵ̞ œː ʏː ə̆',
  'ɵ̥': 'ɵ ɵˑ ɵː',
  'ø̥': 'ø',
  'ɶ': 'œ',
  'oˑ': 'o oː õ ɔˑ',
  'ɵ̞̆': 'a̯ə ə̆',
  'oˤ': 'o',
  'ɵ̞̃': 'ɵ̞',
  'ɵˑ': 'ɵ ɵː ɵ̥',
  'øˑ': 'øː ø',
  'o̟̞': 'o̞',
  'o̞̥': 'o̞ o̞̰ ɔ õ̞',
  'o̞̯': 'ɥ w',
  'o̞̰': 'o̞ o̞̥ o̞ː o̞̰ː õ̞',
  'ɵ̠̞': 'ə ə̠ i ɘ ə̟',
  'õ̞̰': 'õ̞',
  'ɶ̝': 'ɑ ʊ ɐ ɐ̰ ɐ̥ ə',
  'ɵ̞̯': 'ʌ̯ ɜ̯ ɘ̯',
  'o̞ˑ': 'ʊ o̞',
  'o̞˞': 'o̞ õ̞ ɔ',
  'oː': 'o ɔ õː ɔː uː õ ʊː ɤ oˑ u o̞ː ʊ ə o̝ o̰ː ɤː ɤ̞ː o̟ː ŏ o̞ o̤ː ou ɒ ʌ ʷoː o̯ u̯ oˤː ɔːʉ oə ʔo',
  'õː': 'oː õ ũː uː ʌ̃ː ɔ̃ː õ̞ː ɤ̞̃ː ɤ̃ː ɔːʉ o̞ː o ɤ',
  'ɵː': 'ɵ ɵˑ ɵ̥',
  'øː': 'ø øə ɛ̃ ɛ uø ɔː ɪː øˑ',
  'o̞ː': 'o̞ oː oo̞ː ɤː ɤ̞ː ɔː o̞̰ː o̞̰ o̞ə̯ ɔːʉ õː',
  'o̟ː': 'oː',
  'o̤ː': 'oː',
  'o̰ː': 'oː ɔː',
  'õ̞ː': 'ʌ̃ː õː ɔ̃ː ɤ̞̃ː ɤ̃ː',
  'ɵ̞ː': 'ɵ̞̃ː',
  'ø̞ː': 'ø̞ə̯',
  'oˤː': 'oː oːɒ̯ˤ',
  'ɵ̞̃ː': 'ɵ̞ː',
  'o̞̰ː': 'o̞ː o̞ o̞̰',
  'ɶ̝ː': 'ʊː',
  'oːɒ̯ˤ': 'oˤː',
  'oːu': 'uː',
  'oa': 'ɔ',
  'o̞ɔ̯': 'o̞ə̯ o̞i ɵ o̞ uo̞ io̞',
  'œ': 'ɛ ɔ o œː ø̞ ʏː ʏ ə y e a œ̈ ɛː ø œ̝ ɤ ɑ œ̃ œ̞ ɶ <œ> u ö w',
  'œ̈': 'œ',
  'œ̃': 'œ̃ː œ',
  'œ̝': 'ø œ ʏ',
  'œ̞': 'œ',
  'oə': 'oe o̽ə oː',
  'øə': 'øː ø̽ə',
  'o̞ə̯': 'o̞ː o̞i o̞ɔ̯ ɵ o̞ uo̞ io̞',
  'o̽ə': 'oə',
  'ø̞ə̯': 'ø̞ː',
  'ø̽ə': 'øə',
  'œː': 'œ œə ø̞ ʏː',
  'œ̃ː': 'œ̃',
  'œə': 'œː',
  'œi̯': 'oi̯ øi̯',
  'oɤ': 'ɤ e ə e̞ ɪ o',
  'oɤ˞': 'e̞˞ ɤ˞',
  'oi': 'ɔɛ ʊi o',
  'oĭ': 'õ o',
  'oi̯': 'øi̯ œi̯',
  'õi': 'õ',
  'øi̯': 'oi̯ œi̯',
  'o̞i': 'o̞ə̯ o̞ɔ̯ ɵ o̞ uo̞ io̞',
  'o̤i': 'o̤',
  'oj': 'ɔ o o̝',
  'oo̞': 'o̞',
  'oo̞ː': 'o̞ː',
  'ou': 'o u ʊ̈ ɤu oː ɔʊ',
  'oʊ': 'au ʌʊ o',
  'ɵu': 'o u',
  'ɵʊ': 'uː ʉ',
  'o̞u': 'o̞ o',
  'o̯u': 'u ɵ',
  'oʔ': 'o o̰',
  'p': 'b pʰ p̚ pʲ β pʷ ɸ f pː pⁿ pɸ pf ʰp mp v w b̥ bʲ mb pʼ ɓ p̃ β̞ ʔp p̬ p͉ pʰː pˑ ˀp pˡ pʷˠ pˠ b̚ h k bʷ ʔ pʔ pʲʰ p̚ˀ pˀ b͈ pw ph pm ʄ kp m wʲ pu ʰpʰ ʙ̥ pᶣ pfʷ fʲ bʱ bˠ ʃ bɸ βʷ b̰ pɸ̪ pɸ̪ʰ ʔp̚ mʔp̚ p̼ bː hw',
  'p̃': 'p pʰ b β pu pʲ pʔ ʔp b̰ ʰp',
  'pˀ': 'p̚ˀ b bˀ p pʰ',
  'ƥ': 'kp',
  'pʼ': 'pʼː p p̚ ɓ b̰ bˀ b β p̰ʲ pʲʼ',
  'p̚': 'p pʰ b β ɸ pⁿ ɓ pʷ p͉ pʼ pˡ mb w pː pʲ pɸ f pˑ ˀp v b̰ b̚ m bʲ mbʷ bɸ b̥ t͉ t t̚',
  'p̥': 'ʰp hp çp',
  'p̪': 'f',
  'p͉': 'b p p̚ b͉ bⁿ b̚ p͉ː p͉̚ β',
  'p̬': 'p pʰː',
  'p̰': 'ɓ b̰ β b',
  'p̼': 'p',
  'ɸ': 'f p pʰ β v h p̚ b w pɸ pʷ pⁿ ɰ ɸʲ fː ç ɸː ɸʷ ʋ ʍ ɯ̆ ɰ̥ f̃ mp pʰː βʲ hʲ fʷ m̥ n̥ pʲ fʲ x v̥ v̩ çː xː v̼',
  'pˑ': 'p pː p̚ b',
  'p̚ˀ': 'p b pˀ',
  'ɸ̃': 'ɸ̃ʲ',
  'p͉̚': 'p͉ b',
  'ˀp': 'p b ʔ̚ʷ pʲ pʰ p̚ pⁿ',
  'pː': 'p b pʰ pˑ p̚ bː pʲː f pʰː fː pʲ',
  'pʼː': 'pʼ',
  'p͉ː': 'b p͉',
  'ɸː': 'fː ɸ h ç hʲ f çː xː',
  'pf': 'p pʰ f pfʷ pf̃ bf bv bvf',
  'pf̃': 'pf',
  'pfʼ': 'f',
  'pfʰ': 'pʰ',
  'pfʷ': 'pf p pʲ',
  'pˠ': 'p pʷˠ',
  'ph': 'p pʲ',
  'pʰ': 'p p̚ ɸ b f pʲʰ pʷ pʷʰ pⁿ β pː pf pʰː ʰp mpʰ pˡ b̥ p̃ pʲ pʔ ʔp p̬ʰ pfʰ pɸ pˀ ʰpː ʰpˑ ˀp pʷˠʰ w tʰ kʰ pm pu pɸʰ ʰpʰ ʋ bʱ ʔ b̰ pɸ̪ pɸ̪ʰ p̚ʰ b̤',
  'pᶣ': 'p',
  'p̚ʰ': 'pʰ',
  'p̬ʰ': 'pʰ',
  'pʰː': 'p pʰ p̬ ɸ pː fː',
  'pʲ': 'p pʷ b pʲʰ β pʰ p̚ ˀp p̚ʲ pʷˠ pʲː pⁿ ph mb p̃ pu mpʰ pfʷ f ɸ fʲ bʲ pɸʲ pː',
  'pʲʼ': 'pʼ',
  'p̚ʲ': 'pʲʰ pʲ',
  'p̰ʲ': 'pʼ',
  'ɸʲ': 'ɸ',
  'ɸ̃ʲ': 'ɸ̃',
  'pʲː': 'pʲ pː',
  'pʲʰ': 'pʰ pʲ pʷʰ p p̚ʲ pʷˠʰ f',
  'pˡ': 'p̚ pʰ pⁿ p',
  'pm': 'pʰ p',
  'pⁿ': 'p p̚ pʰ ɸ pˡ pʷ ˀp pʲ b β',
  'pɸ': 'p ɸ b f β p̚ pʰ',
  'pɸ̪': 'p pʰ pɸ̪ʰ',
  'pɸʰ': 'pʰ',
  'pɸ̪ʰ': 'p pʰ pɸ̪',
  'pɸʲ': 'pʲ',
  'pu': 'p̃ pʰ pʲ p',
  'pw': 'p f',
  'pʷ': 'p pʲ pʰ p̚ ɸ b pⁿ bʷ ɸʷ f β pʷʰ b̥ʷ mpʰ ʃ',
  'ɸʷ': 'ɸ pʷ f fʷ',
  'pʷˠ': 'p pʷˠʰ p̚ʷˠ pˠ pʲ bʷˠ',
  'p̚ʷˠ': 'pʷˠʰ pʷˠ',
  'ɸʷˠ': 'ɸ̃ʷˠ',
  'ɸ̃ʷˠ': 'ɸʷˠ',
  'pʷˠʰ': 'pʷˠ p̚ʷˠ pʲʰ f pʰ',
  'pʷʰ': 'pʰ pʲʰ pʷ bʷ b̥ʷ',
  'pʔ': 'pʰ p ʔp ʔ b̰ p̃ ʰp',
  'q': 'k qʰ ʁ χ ɢ x ɡ ɣ q̚ qχ kʰ k̚ ʔ qʷ ʀ c kx kʲ qʲ k̟ k̟ʰ k̟̚ qˤ d̠ʒ t̠ʃ kʷ qʼ kʼ ɢ̥ ɣʲ qː kχ ɡx ɣx <q> ʰq ʁ̞ ʁ̥ ʀ̥',
  'qʼ': 'ʛ q̰ ʁ̰ kʼ q q̚ q̪ʼ qʷʼ qʼː qxʼ ʛ̥ χʼ qʼχ ʔ',
  'q̚': 'q ʁ k̚ qʰ k ɡ ɣ qχ kʰ k̟ k̟ʰ k̟̚ ɢ kʷ χ qʷ ʔ qʼ ɡx ɣx',
  'q̰': 'qʼ ʁ̰',
  'qˤ': 'q',
  'q̪ʼ': 'qʼ qʷʼ qʼː',
  'qǃʰ': 'kǃʰ',
  'qː': 'ɢː qˤː q qʷ qʷː',
  'qʼː': 'qʼ q̪ʼ qʷʼ ʛː ʛ̥ː',
  'qˤː': 'qː',
  'qǀʰ': 'kǀʰ',
  'qǁʰ': 'kǁʰ',
  'qǂʰ': 'kǂʰ',
  'qʰ': 'q kʰ k qχ χ q̚ ɢ kx x k̟ k̟ʰ k̟̚ k̚ ʁ qʲʰ ʀ ɢ̥ qx',
  'qʲ': 'q',
  'qʲʰ': 'qʰ',
  'qʷ': 'qʷʰ q kʷ k k̚ q̚ ʁ χ qː',
  'qʷʼ': 'qʼ q̪ʼ qʼː',
  'qʷː': 'qː',
  'qʷʰ': 'qʷ',
  'qx': 'qʰ',
  'qxʼ': 'qʼ ʛ̥ ʛ',
  'qʘʰ': 'kʘʰ',
  'qχ': 'q k qʰ χ kx qχʰ ɣ ɢ ʁ ʀ x kʰ q̚',
  'qʼχ': 'qʼ χʼ ʔ',
  'qχʰ': 'qχ kʲ kʰ k',
  'qχʰː': 'kː',
  'r': 'ɾ l d r̥ ɹ rʲ ɽ rː t ʁ n ɾ̥ ʀ r̩ ɻ ɺ rʷ z͇ ɣ ɗ ɐ̯ ʁ̞ l̃ d̠ʒ rˑ ʌ̯ tʰ s dr ɾ̞ ɾ̪ l̪ ɬ c ɟ r̞ ʁ̥ ∅ l̥ ʐ ɾ͓ ʒ ɺ̃ ʌ rʷˠ rˠ z͇̥ tʷ dʷ z t̚ ʔr rʱ ɾ̃ ɳ̆ ɾ̪ˠ x nr ŋ m ɲ a dz nt d̠ʒʷ lʷ lʲ tr ɖ ɭ lː d̪ ɾʷ ʀ̥ ɢ̆ ɹ̞ ɾɹ̞ ɾ̩ ɻː ʋ ɰ h d̚ ˀr̥ ə rr̥',
  'ʀ': 'r ʁ ʁ̞ χ ɢ q ʀ̥ ɾ ʁ̥ ɣ qχ ʌ ʌ̯ k ɰ ɢ̥ qʰ r̥ ɢ̆ ɹ ʋ ə ɐ',
  'ʁˤ': 'ʁ',
  'r̃': 'ɾ l ɺ ɲ',
  'ʁ̞̥': 'ʁ̞',
  'ɻ̥̩': 'i̥ ɻ̩ i s̞̩ z̞̩',
  'ɽ': 'ɖ r ɾ ɻ l ɽʲ r̠ ɽ̥ ɺ ɽ̃ d ʈ r̥ ˀɖ ɹ ʐ ʈɽ d̠ʒ ɭ ɺ̥ ʈʼ ʈ̚ ᶑ l̪ ɖʷˠ ɖʲ ɳɖ ɗ ɽʷ nd ɳ̆ d̚ ʈʰ ɖ̥ t ʎ rː ɻː ˀr̥',
  'r̞': 'r ɾ ɹ̞ ɾɹ̞ rː ɾ̞',
  'r̠': 'r̠̃ ɽ ɹ ɽ̥ ʈɽ ʐ͇',
  'r̥': 'r ɾ ɾ̥ ɽ r̥ˑ r̥ʲ hr ʀ ʀ̥ ʁ̞ ˀr̥ rr̥',
  'ʀ̥': 'ʁ̞ χ ʀ x̟ x r r̥ ʁ ʁ̥ q',
  'r̩': 'r ɾ ɹ ʁ ɾʲ ɾ̩ l',
  'r̪': 'd̪ d̪̚ ɾ̪ r̪ʲ r̪̥ r̪ː ɾ',
  'r̠̃': 'r̠',
  'ɹ': 'ɾ r l d ɹ̥ ʋ r̩ ʁ t ɹ̃ ʔ ɽ r̠ d̃ ɣ ɯ̯ x ɐ̯ ɻ n n̪ d̪ l̪ ɾ̥ j tʰ ts θ ð h ʰsʰ z s w ɾʲ ʝ ɾˠ ɹˠ ʀ ɰ ə əɹ',
  'ɺ': 'l ɾ r ɭ d ɺ̥ ɽ ɬ d̠ʒ ɽ̥ ɽ̃ l̃ ɺ̃ dː ɾʲ r̃ ɲ',
  'ɾ': 'r l d ɹ t r̥ ɾ̃ ɾ̥ ɺ n ɽ t̚ tʰ ɾː rː ʔ z͇ ʁ ɻ ɾʲ ð rʲ z͇̥ r̩ z s d̥ tʔ ɰ lʲ ʐ ɭ ɖ ʐ͇ ɹ̥ ɾʷ nd m ɐ̯ r̃ dʷ lʷ ʀ nɪ̯ dɪ̯ tʰɪ̯ ts d̻ d̠ ∅ ɾ͓ ɬ ɺ̠ d̠ʒ ɹ̩ nt ɺ̃ ɻ̥ ʂ͇ dr dn rʱ ɾ̞ t̪ n̪ l̃ x nr a d̪ ɗ ɾ̚ t̪̚ tç ʃ l̥ ɫ ʔr ɲ ɹ̚ lʰ rʷ ɢ̆ r̞ ɹ̞ ɾɹ̞ dʔ dⁿ dˡ tⁿ tˡ θ h ʰsʰ ʔt ʋ l̩ ɾ̩ ʁ̥ ʁ̞ d̠͓ l̠ d̠ʲ ʎ ɰʷ ˀr̥ <ɾ> ə r̪ rr̥ t̠ ʈ t̠ʔ ʈʔ t̠̚ ʈ̚',
  'ʁ': 'q ɣ χ ɢ ɡ r ʀ k ʁ̥ ɾ q̚ ʕ ʁ̞ ɐ χ͉ ɹ ʁʲ ʔ k̚ ə qχ ɢʁ qʰ ʁˤ x r̩ ɡʲ kʰ kʷ qʷ ɣʲ t ⱱ ɡx ɣx ʋ ʑ ∅ ʁʷ ʁ̥ʷ χʷ ʀ̥',
  'rˑ': 'r rː',
  'ɹ̃': 'ɹ l̪',
  'ɺ̃': 'ɾ ɺ r',
  'ɾ̃': 'ɾ l n ɾ̥ ɺ̠ d r l̃ j̃',
  'ɽ̤': 'ɖ̤ ɳɖ̤',
  'ɽ̥': 'ɽ r̠ ʈɽ l ɭ ɺ̥ ɺ ɽ̃',
  'r̪̥': 'r̪',
  'ɹ̚': 'l ɾ lʷ',
  'ɾ̚': 'ɾ',
  'ɺ̠': 'ɾ̃ ɾ',
  'ɾ̞': 'r ɾ rː r̞',
  'ʁ̞': 'ʀ ʀ̥ r ʁ ʁ̥ ɰ ʔ ʁ̞̥ r̥ ɾ ɣ q',
  'ɹ̥': 'ɹ ɾ ɾ̥',
  'ɺ̥': 'ɺ ɽ̥ ɽ l ɭ ɽ̃',
  'ɻ̥': 'ɻ ʐ͇ ɾ',
  'ɾ͓': 'ɾ ɾ̥ r',
  'ɻ̩': 'i̥ i s̞̩ ɻ̥̩ z̞̩',
  'ɾ̩': 'ɾ r r̩ l',
  'ʁ̥': 'ʁ ʁ̞ ʀ r χ ʔ ɐ ɾ x͉ x ʀ̥ q',
  'ɾ̪': 'd̪ r t̪ d̪̚ r̪ t̪̚ t̪ⁿ ð θ d̪̥',
  'r̥ˑ': 'r̥',
  'ɾ̰': 'ɗ̪',
  'ʁ̰': 'q̰ qʼ',
  'ˀr̥': 'ɾ r r̥ ɽ',
  'rː': 'r ɾ rˑ t d ɽ r̞ ɾ̞ rr̥ː',
  'r̪ː': 'r̪',
  'ɻː': 'ɽ r',
  'ɾː': 'ɾ',
  'ʁː': 'ʁˤː ʁ̥ː χː ʁʷː ʁ̥ʷː χʷː',
  'ʁ̥ː': 'ʁː χː',
  'rˠ': 'rʷˠ rʲ r',
  'ɹˠ': 'ɾˠ ɹ',
  'ɾˠ': 'ɾ̪ˠ ɾ̃ˠ ɹ ɹˠ',
  'ɾ̃ˠ': 'ɾˠ ɾ̪ˠ',
  'ɾ̪ˠ': 'ɾˠ ɾ̃ˠ r',
  'rʱ': 'r ɾ ɾʱ',
  'ɽʱ': 'ɗʱ',
  'ɾʱ': 'rʱ',
  'rʲ': 'r ɾ rʷ r̥ʲ ɾʲ rʷˠ rˠ d',
  'ɽʲ': 'ɽ ɽʷ',
  'r̥ʲ': 'ɾʲ rʲ r̥',
  'r̪ʲ': 'r̪',
  'ɺʲ': 'ɺ̥ʲ',
  'ɾʲ': 'ɾ ɾ̃ʲ r̥ʲ rʲ r̩ ɺ ɾ̥ ʝ ɹ',
  'ʁʲ': 'ʁ ʕ',
  'ɾ̃ʲ': 'ɾʲ',
  'ɺ̥ʲ': 'ɺʲ',
  'ɾl': 'l',
  'ɾn': 'n',
  'rr̥': 'r ɾ r̥',
  'ʀʁ': 'ʀ̥ʁ̥',
  'ʀ̥ʁ̥': 'ʀʁ',
  'ɾɹ̞': 'r ɾ r̞ ɹ̞',
  'rr̥ː': 'rː',
  'rʷ': 'r rʲ ɾ d',
  'ɽʷ': 'ɽ ɽʲ',
  'ɻʷ': 'ɻ ʲɻ',
  'ɾʷ': 'ɾ r',
  'ʁʷ': 'ʁ ʁ̥ʷ χʷ',
  'ɾ̥ʷ': 'ɾ̥',
  'ʁ̥ʷ': 'ʁʷ ʁ χʷ',
  'ʁʷː': 'ʁː ʁ̥ʷː χʷː',
  'ʁ̥ʷː': 'ʁʷː ʁː χʷː',
  'rʷˠ': 'rˠ rʲ r',
  's': 'ʃ z sʲ ts sː sʷ h t̠ʃ ɕ ç t ʂ c sˑ ʒ s̪ s͉ s̻ ɾ s̬ s̩ s̃ sʷˠ ns sˤ r θ n ʃː dz t̠ʃʰ t̠ʃʲʰ t̻ʰ t̻ zː ʃ͈ s͈ ʂː ʃ̃ z͈ sˠ ʐ ɦ tsʲ ̩ʃ ch tʰ d̪ j ɲ tw ʲt ʲt̚ k ʔ ʰs z̥ ʃʷ tsʷ tɕ f ʷs sʷʲ t̠ʃʷ t̪ cʰ z̻ zʲ s̟ ɹ ʋ ʃ̬ ɕʰ ʲh ʲç ∅',
  's̃': 's ʃ̃ ʃ sʲ sʷ',
  'sˀ': 'tsʼ',
  'ʂ': 'ʃ s ʐ sː ʂː ʂɻ',
  'sʼ': 'tsʼ sʼː',
  's̟': 's s̪ ʃ',
  's̩': 's',
  's̪': 's z̪ ʃ ts s̻ s̪ʲ t̪ tˠ d̪ ʒ sˠ ɕ s̟ s̬ z̪̥ z',
  's͉': 'z s sː ɕ',
  's̬': 's s̪',
  's̰': 'ʒ d̠ʒ z',
  's̺': 'z̺ t̺s̺',
  's̻': 's ʃ d̻ t̻ t̻̚ z̻ s̻͉ s̻ʲ s̻ˑ θ s̪',
  's͈': 'ʃ͈ s z',
  'ʃ': 's ʒ t̠ʃ ʃʲ ʃː ʂ c z h ʃʷ ɕ ts sʷ ʃˑ s̪ d̠ʒ hʲ ʃ̩ s̻ t̠ʃʰ sʲ j ʒ̥ cç ɟʝ sː ç cçʰ ʒː s̻͉ ʃˤ ʃ̃ s̃ ʒ͈ ð ʲt ʲt̚ s̪ʲ iʃ ʔt̠ʃ ʔʃ tsʷ ɕᶣ ɾ p pʷ s̟ k ʃ̬ ʃ͉ x xː ʒ̊ ʑ n̥ l̥',
  'sˑ': 's sː',
  'sˤ': 's',
  'ʃ̃': 's ʃ s̃',
  's̞̩': 'i̥ ɻ̩ i ɻ̥̩ z̞̩',
  'ʂ͇': 'ʐ͇ ɻ ɾ',
  's̪͉': 'z̪',
  's̪̻': 't̪̻s̪̻',
  's̻͉': 's̻ ʃ',
  'ʃ̩': 'ʃ',
  'ʃ͉': 'ʒ ʃ',
  'ʃ̬': 'ʃ s',
  's̻ˑ': 'θ s̻',
  'ʃ͈': 's͈ s z',
  'ʃˑ': 'ʃ ʃː sː',
  '̩ʃ': 's',
  'ʃˤː': 'ʃː ʒˤː ʒ̥ˤː',
  'sː': 's ʃː z sˑ ʃ zː s͉ ʂ ʂː ʃˑ t̠ʃ ts',
  'ʂː': 'ʂ sː s',
  'sʼː': 'sʼ tsʼː',
  's̪ː': 'z̪ː z̪̥ː',
  'ʃː': 'ʃ sː ʒː s h ʒ ʃˤː ʃˑ n̥ l̥ ʒ̥ː',
  's̪ˤː': 'z̪ˤː z̪̥ˤː',
  'ʃ͈ː': 'ʃ͈ʲː',
  'sˠ': 'sʷˠ s s̪',
  'ʃˠ': 'ʃʲ',
  'sʲ': 's sʷ t̠ʃ ʃʲ j zʲ ʃ t̠ʃʰ t̠ʃʲʰ ts sʷˠ sʲː ɦ h ns ɕ ʒ s̃ ʷs sʷʲ t̠ʃʷ',
  'sʲˑ': 'sʲː',
  's̪ʲ': 's̪ ʃ',
  's̻ʲ': 's̻',
  'ʃʲ': 'ʃ sʲ ʒ ʃˠ ʃʷ ʒʲ t̠ʃʰ t̠ʃˀ t̠ʃ ʃʷˠ',
  'sʲː': 'zʲ sʲ sʲˑ',
  'ʃ͈ʲː': 'ʃ͈ː',
  'sɬ': 'ɬ',
  'ʂɻ': 'ʂ',
  'st': 'tʰ t ʰt',
  'sts': 'tsʰ ʰtsː stsː ʰts ts',
  'st̠ʃ': 't̠ʃʰ ʰt̠ʃ t̠ʃ',
  'ʃt̠ʃ': 'ʰt̠ʃ',
  'stsː': 'tsʰ ʰtsː sts ʰts ts',
  'sʷ': 's sʲ ʃ ç ns s̃ t̠ʃ t̠ʃʷ z',
  'ʃʷ': 'ʃ ʃʲ s ts tsʷ ʒ',
  'sʷˠ': 's sˠ sʲ',
  'ʃʷˠ': 'ʃʲ',
  'sʷʲ': 's ʷs sʲ',
  'ʃʷʲ': 'fʷ',
  's̻θ': 'θː',
  't': 'tʰ d t̚ tʲ t̪ ɾ tʷ tː t̠ʃ ts r ð tⁿ ʈ ʔ θ nt c s d̪ l n ʰt tʔ t͉ ɖ nd t̪̚ tˡ tˤ d̥ tˑ ˀt tʼ d͈ tʷˠ tˠ ɡ t̠ ɹ t̃ dʲ tʰɪ̯ ʔt tʲʰ nˀ t̚ˀ k t̪θ t͈ t͈̚ tʰː st dⁿ t̻ʰ tˀ t̪ˡ t̪ⁿ t̪ʰ ð̞ d̚ b tw ʒ t̻ d̪̥ ɗ ʰtʰ t̠ʃʷ tsʷ ʁ ⱱ ʷt tʷʲ tç ɽ rː ɬ ɟ dʷ t̪θ̪ ʈθ̜ l̪ ɭ d̪θ̪ ɖθ̜ l̪ɬ̪ ɭɬ̜ t̠ʃʰ t̺ t̺̚ cʃ ɟʒ h ʰsʰ d̰ t̬ p̚ t̠ʔ ʈʔ d̠ t̠̚ ʈ̚',
  't̃': 'tʰ t tʷ tʔ ʔt d̰ ʔ t̚',
  'tˀ': 'dˀ jˀ tʰ t tʲˀ',
  'tʼ': 'tʼː ɗ t d d̰ dˀ ʈʼ t̚ ð t̪̰ʲ t̠ʃ tʷʼ',
  't̚': 't tʰ d t̪ ɾ tʲ tⁿ t̪̚ tˡ θ tʔ ʔ tʷ t͉ ʈ tˠ d̰ tː d̪ ɖ tˑ tʼ ð dː ts ˀt tʷˠ r nd d̚ n t̪ʰ d̪̥ ɗ tç l̪ ɭ d̪θ̪ ɖθ̜ l̪ɬ̪ ɭɬ̜ t̺ t̺̚ d̥ ʔt t̃ p̚ tɕ tɕʰ t͉ɕ͉ t̻ t̠ t̠ʔ ʈʔ d̠ t̠̚ ʈ̚',
  't̠': 't ʈ t̠ʔ ʈʔ tʔ ʔ d̠ ɖ d ɾ t̠̚ ʈ̚ t̚',
  'ʈ': 'ɖ t ʈ̚ ʈʰ t̪ d ʈʂ t̚ tʰ ɽ ʈʲʰ ʈ̚ˀ ʈⁿ ʈˡ ts tˡ ˀt tⁿ ʈʷˠ ʈʲ c tʷ ʈː t̪θ̪ ʈθ̜ ʈʷ ʲʈ t̠ t̠ʔ ʈʔ tʔ ʔ d̠ ɾ t̠̚',
  't̥': 'ʰt ht çt',
  't̪': 'd̪ t̪ʰ t t̪̚ t̚ tʰ ð θ d t̪ʲ tʲ t̪ː t̻ ʈ t̪ʷ t̪ⁿ ts ɾ̪ d̪ʉ t̪ʲʰ d̻ d̪ð t̪θ t̻̚ t̪s̪ t̪ˡ tˡ ˀt tⁿ c th t̪ʔ ɾ tˠ s̪ ʒ dˠ t̠ʃ tʷ t̰ t̪θ̪ ʈθ̜ s t̺ t̺̚ ð̞ f t̪s̪̟ t̪s̪̟ʰ t̪̬ t̪ʰː t̪ʃ̟',
  't͉': 'd t t̚ ð d͉ dˡ d̪ dⁿ ɖ dz d̚ p̚ t͉̚',
  't̬': 't',
  't̰': 'd t̪ θ c',
  't̺': 'ʔt t̺β t t̪ t̪̚ t̺̚ t̚ t̻ ʔt̻̚ nʔt̻̚',
  't̻': 'd̻ t̪ t̻ʰ d̪ t̻̚ z̻ s̻ ts s t d tʰ ʔt̻̚ nʔt̻̚ t̺ t̺ʰ t̚',
  't͈': 't d t͈̚',
  'tˑ': 't tː t̚ d',
  'tˤ': 't t̚ˤ',
  't̚ˀ': 'nˀ t',
  'ʈʼ': 'tʼ ʈ̚ ɽ ᶑ',
  't̠̚': 't̠ ʈ t t̠ʔ ʈʔ tʔ ʔ d̠ ɖ d ɾ ʈ̚ t̚',
  'ʈ̚': 'ʈ ɖ ʈʰ ʈʼ ɽ ᶑ ʈⁿ ʈˡ t̠ t t̠ʔ ʈʔ tʔ ʔ d̠ d ɾ t̠̚ t̚',
  't̥̚': 't̠ʃ t̠ʃʼ',
  't̪̚': 't̪ t̪ʰ t̚ t d̪ t̪ⁿ d t̪ʲ t̪ˡ t̠ʃ ɾ̪ ð θ ɾ tʰ tç t̺ t̺̚',
  't͉̚': 't͉ d',
  'ʈ͉': 'ɖ',
  't̺̚': 't t̪ t̺ t̪̚ t̚',
  't̻̚': 'd̻ t̻ z̻ s̻ t̪ t̪ʰ',
  't̪̬': 't̪ d̪ t̪ʰː',
  'ʈ̺': 'ɖ̻',
  't͈̚': 't͈ t d',
  't̚ˤ': 'tˤ',
  't̪ˤ': 'd̪ˤ',
  'ʈ̚ˀ': 'ʈ',
  'ˀt': 't tʰ tʲ ts tˡ t̚ ʈ tⁿ t̪',
  'tː': 't tʰ tˑ d t̚ tʰː tʲː t̪ː tʲ',
  'tʼː': 'tʼ',
  'ʈː': 'ʈ ɖː',
  't̪ː': 't̪ d̪ː tː ð d̪ t̪ʰ',
  'tːs': 'tːʃ ts tɕ tsː',
  'tːʃ': 'tːs t̠ʃ t̠ʃː',
  'tç': 't t̚ d ɾ tʰ t̪̚',
  'tɕ': 'c tɕʰ ts c̚ s tːs t̚ ʔc̟̚ ʔc̟ʰ ʔtɕ̚',
  't͉ɕ͉': 't̚',
  'tɕʰ': 'cʰ tɕ ɕ t̚ tsʰ',
  'tɕᶣ': 't̠ʃ',
  'tˠ': 't t̚ tʷˠ tˡ tⁿ t̪ d̪ s̪ ʒ',
  'th': 't̪ t̪ʲ',
  'tʰ': 't t̚ d tʲ t̪ ʔ ɾ tʲʰ tː tⁿ ts tʔ tˡ tʷ t̃ n ʔt tʷʰ ʈʰ t̪θ tʰː ntʰ ʰtˑ ʰtː ˀt ʈ θ r t̠ʃ t̪ʰ tʰɪ̯ d̰ t̬ʰ tχ cç txʷ tx st ʰt tsʰ t̻ʰ tˀ tʷˠʰ w pʰ kʰ s t̻ d̪ d̪̥ tn ʰtʰ l d̥ t̪̚ tç t̺ʰ ð h ʰsʰ ɹ t̠ʰ d̠̈ ɖ̤ d̤',
  'tɥ': 'tʷ',
  't̠ʰ': 'ʈʰ tʰ d̠̈ ɖ̤ d̤',
  'ʈʰ': 'ʈ ʈʲʰ tʰ ʈ̚ ɖ ʈⁿ ʈˡ ʈʷˠʰ ɽ ʈ̚ʰ t̠ʰ d̠̈ ɖ̤ d̤',
  't̪ʰ': 't̪ t̪̚ t̪ʲ d̪ tʰ t̪ʲʰ t̻̚ t̪ˡ t̪ⁿ t t̪ʔ tʲ t̚ t̪ː t̺ʰ t̪s̪̟ t̪s̪̟ʰ t̪̚ʰ t̻ʰ',
  't̬ʰ': 'tʰ',
  't̺ʰ': 't̪ʰ tʰ t̻ʰ t̻',
  't̻ʰ': 't̻ ts s tʰ t t̺ʰ t̪ʰ',
  'ʈ̚ʰ': 'ʈʰ',
  't̪̚ʰ': 't̪ʰ',
  'tʰː': 'tʰ tː t t̪θ',
  't̪ʰː': 't̪ t̪̬ d̪',
  'tʰɪ̯': 'tʰ t ɾ',
  'tʲ': 't tʷ tʰ t̚ d t̪ tʲʰ c t̠ʃʲ t̠ʃ dʲ tʷʲ cç ˀt tʲː tʷˠ ts t̪ʰ t̪ʔ nd t̪ʷ ntʰ ʷt cʃ tsʲ t̬ʲ tː kʲ',
  'tʲˀ': 'tˀ',
  'tʲˑ': 'tʲː',
  't̚ʲ': 't̻ʲ t̻ˡʲ t̻ⁿʲ',
  'ʈʲ': 'ʈʷˠ ʈ',
  't̪ʲ': 't̪ t̪ʰ t̪̚ th',
  't̬ʲ': 'tʲ',
  't̻ʲ': 't̚ʲ t̻ˡʲ t̻ⁿʲ',
  't̪̰ʲ': 'tʼ',
  'tʲː': 'tʲˑ tʲ tː',
  'tʲʰ': 'tʰ tʲ t tʷʰ cç tʷˠʰ dʲ',
  'ʈʲʰ': 'ʈʰ ʈ ʈʷˠʰ',
  't̪ʲʰ': 't̪ t̪ʰ',
  'tˡ': 't̚ tʰ tⁿ t ts ˀt ʈ t̪ tʷˠ tˠ ɾ tʔ ʔ',
  'tɬ': 'ɬ tɬʰ ɬʲ tɮ dɮ',
  'tɬʼ': 'tɬ̩ʼ ɬ ɬʼ kɬʼ',
  'tɬ̩ʼ': 'tɬʼ',
  'ʈˡ': 'ʈⁿ ʈ̚ ʈ ʈʰ',
  't̪ˡ': 't̪̚ t̪ t̪ⁿ t t̪ʰ',
  'tɬʰ': 'tɬ',
  'tɬʲʼ': 'ɬʲʼ',
  't̻ˡʲ': 't̚ʲ t̻ʲ t̻ⁿʲ',
  'tn': 'tʰ',
  'tⁿ': 't t̚ tʰ tˡ ts ˀt ʈ t̪ tʷˠ tˠ ɾ tʔ ʔ',
  'ʈⁿ': 'ʈ̚ ʈ ʈʰ ʈˡ',
  't̪ⁿ': 't̪̚ t̪ t̪ˡ t t̪ʰ d̪ ɾ̪ ð θ',
  't̻ⁿʲ': 't̚ʲ t̻ʲ t̻ˡʲ',
  'ȶȵ': 'ȶȵʷ',
  'ȶȵʷ': 'ȶȵ',
  'tp': 'kp',
  'tr': 't̠ʃ r',
  'ʈɽ': 'r̠ ɽ̥ ɽ',
  'ʈr̠̥': 'ʈʂ͇',
  'ts': 't̠ʃ dz s tsʰ t tsʷ tsʲ z tʰ ʃ d̠ʒ tsː ʰts t̪ nts c ʒ h t̪s̪ ɾ ʔ tɕ s̪ t̻ʰ t̻ sʲ ʰtsː stsː sts t̻s̻ tˡ ˀt t̚ ʈ tⁿ tsʷˠ ʈʂ tʲ ʲt ʲt̚ t̪s dz̥ ts̃ t̠ʃʷ ʃʷ ʷts tsʷʲ t̠ʃː t̪̻s̪̻ d̥z̥ t̟s̟ d θ ð ʰsʰ ɹ tʔ ʔt tːs sː',
  'ts̃': 'ts tsʷ',
  'tʂ': 't̠ʃ d̠ʒ',
  'tsʼ': 't̠ʃʼ sʼ tsʼː dz̰ dzˀ sˀ ts̰ʲ',
  'tʂʼ': 't̠ʃʼ',
  't̟s̟': 'ts d̥z̥ t̪s̪ t̠ʃ',
  't̠ʃ': 'ts d̠ʒ t̠ʃʰ ʃ t c t̠ʃʷ s k t̠ʃː t̠ʃʲ ʒ sʲ ʰt̠ʃ d tsʷ c̚ tʲ n̠t̠ʃ ɟ c̟̚ c̟ tʰ ʲt̚ t̠ʃʼ t̠ʃ̚ z t̠ʃʲʰ st̠ʃ t̠ʃˑ t̻s̻ t̠ʃˀ ʃʲ ˀt̠ʃ cʰ h q ʲt ɟ̰̩ ʲd̚ ç tʼ tʂ ŋ ɣ j n tr t̪ t̪̚ tːʃ n̠d̠ʒ dz ʔt̠ʃ ʔʃ nts tɕᶣ ɡ sʷ tsː t̥̚ d̥z̥ t̟s̟ t̪s̪ t̬ʃ t̠ʃʰː tʃː sː',
  't̠ʃˀ': 't̠ʃʰ t̠ʃ ʃʲ',
  't̠ʃʼ': 'tsʼ t̠ʃʼː t̠ʃ d̠ʒ̰ t̠ʃ̩ʼ d̠ʒˀ t̠ʃ̰ʲ tʂʼ t̠ʃʲʼ c t̥̚',
  't̠ʃ̚': 't̠ʃ t̠ʃʰ d̠ʒ',
  't̠ʃ͉': 'd̠ʒ t̠ʃː d̠ʒ͉ ʒʲ',
  't̠ʃˑ': 't̠ʃ',
  't̠ʃ̩ʼ': 't̠ʃʼ',
  'ʈʂ': 'ʈ ɖʐ ts ʈʂʰ',
  'ʈʂ͇': 'ʈr̠̥',
  't̥s': 'ʰts hts çts',
  't̥ʃ': 'ʰt̠ʃ ht̠ʃ çt̠ʃ',
  't̪s': 'dz̥ ts tsʰ dz',
  't̪s̪': 'ts t̪ tsʲ t̪̻s̪̻ d̥z̥ t̟s̟ t̠ʃ',
  't̪s̪̟': 't̪ t̪ʰ t̪s̪̟ʰ',
  't̪ʃ̟': 't̪',
  't͉s': 'dz d͉z d͉zː',
  't̬ʃ': 't̠ʃ d̠ʒ t̠ʃʰː',
  't̺s̺': 's̺',
  't̻s̻': 't̻s̻ʰ t̠ʃ ts',
  't̻s̻ʼ': 't̻s̻̩ʼ',
  't̻s̻̩ʼ': 't̻s̻ʼ',
  't̪̻s̪̻': 's̪̻ ts t̪s̪',
  'ˀt̠ʃ': 't̠ʃ',
  't̪ʃ|t̠ʃ': 'd̪ʒ|d̠ʒ',
  'tsː': 'ts t̠ʃː tsʰ t̠ʃ tːs',
  'tsʼː': 'tsʼ sʼː',
  'tʃː': 't̠ʃ',
  't̠ʃː': 't̠ʃ tsː t̠ʃ͉ d̠ʒ͉ t̠ʃʰː t̠ʃʰ cː ts tːʃ',
  't̠ʃʼː': 't̠ʃʼ cʼː',
  'tsç': 'tsxʷ tsʰ tsx',
  'tsʰ': 'ts t̠ʃʰ tsʲʰ dz t̪s̪ʰ t̬sʰ tsʷʰ tsxʷ tsç tsx ʰtsː stsː sts ʰts tʰ c ntsʰ tsʷˠʰ t̪s dz̥ tsː t̪̻s̪̻ʰ t̟s̟ʰ tɕʰ',
  't̟s̟ʰ': 'tsʰ t̪s̪ʰ t̠ʃʰ',
  't̠ʃʰ': 't̠ʃ tsʰ t̠ʃʲʰ d̠ʒ ʃ t̠ʃ̚ t̠̬ʃʰ sʲ s st̠ʃ ʰt̠ʃ t̠ʃˀ ʃʲ kʰ t̠ʃʷʰ t̠ʃː t t̟s̟ʰ t̪s̪ʰ',
  't̠ʃɥ': 't̠ʃʷ',
  'ʈʂʰ': 'ʈʂ',
  't̪s̪ʰ': 'tsʰ t̪̻s̪̻ʰ t̟s̟ʰ t̠ʃʰ',
  't̪s̪̟ʰ': 't̪ t̪ʰ t̪s̪̟',
  't̬sʰ': 'tsʰ',
  't̻s̻ʰ': 't̻s̻',
  't̠̬ʃʰ': 't̠ʃʰ',
  't̪̻s̪̻ʰ': 'tsʰ t̪s̪ʰ',
  't̠ʃʰː': 't̠ʃː t̠ʃ t̬ʃ d̠ʒ',
  'tsʲ': 'ts tsʷ tsʷˠ dzʲ s t̪s̪ ʷts tsʷʲ tʲ',
  'ts̰ʲ': 'tsʼ',
  't̠ʃʲ': 't̠ʃ tʲ k̟ʲʰ k̟x̟ʲ d̠ʒʲ t̠ʃʷˠ t̠ʃʷ',
  't̠ʃʲʼ': 'k̟ʲʼ t̠ʃʼ',
  't̠ʃ̰ʲ': 't̠ʃʼ',
  'tsʲʰ': 'tsʰ tsʷʰ tsʷˠʰ',
  't̠ʃʲʰ': 't̠ʃʰ t̠ʃ sʲ s t̠ʃʷˠʰ',
  'tsʷ': 'ts t̠ʃ t̠ʃʷ tsʲ ts̃ nts t s ʃʷ ʃ',
  't̠ʃʷ': 't̠ʃ tsʷ t̠ʃʲ t ts t̠ʃɥ s sʲ sʷ',
  't̠ʃʷʼ': 't̠ʃ̩ʷʼ',
  't̠ʃ̩ʷʼ': 't̠ʃʷʼ',
  'tsʷˠ': 'ts tsʲ',
  't̠ʃʷˠ': 't̠ʃʲ',
  'tsʷˠʰ': 'tsʰ tsʲʰ',
  't̠ʃʷˠʰ': 't̠ʃʲʰ',
  'tsʷʰ': 'tsʰ tsʲʰ',
  't̠ʃʷʰ': 't̠ʃʰ',
  'tsʷʲ': 'ts ʷts tsʲ',
  'tsx': 'tsxʷ tsç tsʰ',
  'tsxʷ': 'tsç tsʰ tsx',
  'tw': 't s',
  'tʷ': 't tʲ tʰ d t̚ r t̪ t̃ ʈ tɥ',
  'tʷʼ': 'tʼ ɗ',
  'ʈʷ': 'ʈ ʲʈ ɖ',
  't̪ʷ': 't̪ tʲ d̪',
  'tʷˠ': 't tˡ tⁿ t̚ tˠ tʲ',
  'ʈʷˠ': 'ʈʲ ʈ',
  'tʷˠʰ': 'tʲʰ tʰ',
  'ʈʷˠʰ': 'ʈʰ ʈʲʰ',
  'tʷʰ': 'tʰ tʲʰ',
  'tʷʲ': 'tʲ t ʷt dʲ',
  'tx': 'cç txʷ tʰ',
  'txʷ': 'cç tʰ tx',
  'tz̤̥': 'dz',
  'tʔ': 'tʰ t ʔ t̚ ɾ ʔt tⁿ tˡ ts d̰ t̃ t̠ ʈ t̠ʔ ʈʔ d̠ ɖ d t̠̚ ʈ̚',
  't̠ʔ': 't̠ ʈ t ʈʔ tʔ ʔ d̠ ɖ d ɾ t̠̚ ʈ̚ t̚',
  'ʈʔ': 't̠ ʈ t t̠ʔ tʔ ʔ d̠ ɖ d ɾ t̠̚ ʈ̚ t̚',
  't̪ʔ': 't̪ t̪ʰ tʲ',
  't̺β': 't̺ ʔt',
  't̠θˀ': 'θ t̪θ t̪θʰ',
  'ʈθ̜': 't t̪ ʈ t̪θ̪',
  't̪θ': 'θ tʰ t t̪ t̠θˀ t̪θʰ tʰː',
  't̪θʼ': 'θʼ',
  't̪θ̪': 't t̪ ʈ ʈθ̜',
  't̪θ͉': 'd̪ð ð',
  't̪θʰ': 'θ t̪θ t̠θˀ',
  'tχ': 'tʰ',
  'u': 'ʊ ũ uː o u̥ w ʉ y ɯ ɨ i ə ŭ ṵ ɔ uˑ ʊ̃ u̟ o̞ ɪ ɐ ɥ oː uʔ ʊu v̩ f̩ uɘ ʊə̯ ɯ̃ ou ʊ̆ ŭ̥ ʏ ɵ ɤ b uˤ wʊ ʋ u̯ ∅ z̞̩ʷ ʊ̥ ʊ˞ ɔː u˞ ɔ̴ ɵu ɔ̆ o̰ õ̞ uu̯ ʊ̟ ʊ̈ ʊ̥̆ o̯u u̥ː ɨː iː uɪ ʊː ʷu v õ o̥ ɨ̃ ʍ wə m mb ɯˑ ɯː ɯ̥ uj ũj u͓ ŭ̃ wiy ẅiy ŋʷ ũː w̃ u̞ a aː ü̜ ɯ̈ ʙ̩ ui uʊ̯ au ɒ œ ö əʊ',
  'ü': 'ö ə̈ üʲ ʉ̈ʲ üː ʉ̈ː ʉ̈ ʉ',
  'ŭ': 'u uː ʊ̆ ʊ u̥ o̞ ŭ̥ y̆ ũ ŭ̃ w ŏ',
  'ũ': 'u uː u̥ w ʊ ʊ̃ õ ṵ y ɯ ɔ̃ o m̩ ỹ uˑ ũˤ ɨ̃ u͓ ɨ ŭ ŭ̃ w̃ ũː ʙ̩ ũi ∅ uʔ ŋ ɴ',
  'ʉ': 'u ə ʊ ɨ ʉ̃ i ɯ ɨ̥ ɪ ɵ ɒ ʊ̈ y w ü ʉ̞ ʉː ʷu uː ɵʊ uʔ ṵ',
  'ŭ̃': 'u ũ ŭ',
  'ʉ̈': 'üʲ ʉ̈ʲ üː ʉ̈ː ü',
  'ʉ̃': 'ʉ',
  'u̘': 'ũ̘',
  'u̙': 'ũ̙',
  'u̞': 'u',
  'u̟': 'u',
  'u̠': 'ʊ',
  'u͓': 'u ũ uː ɨ ʊ',
  'u̥': 'u ũ ṵ ɯ v̩ ʊ f̩ uɘ ɔ̴ o ɔ uˑ ŭ o̞ w ʊ̥ ü̜ ɯ̈',
  'u̯': 'w u o̯ uː o oː ʊ uj ũj',
  'ṵ': 'u u̥ ũ ɔ uʔ ʉ',
  'ũ̘': 'u̘',
  'ũ̙': 'u̙',
  'ŭ̥': 'u ŭ',
  'ʉ̞': 'ʉ',
  'ʊ': 'u o ʊ̃ uː ə ʊ̆ w ʊ̥̆ ʊ̥ ɔ ʊː ʉ ɨ ũ ɪ õ y ʊ̈ o̞ ʏ i ʊ̟ ʊ˞ u˞ ɔː ɯ̞ ɤ ʊ̰ ʊ̤ ɯ oː o̝ wʊ ʊu v̩ u̥ f̩ uɘ ɔ̥ ui ə̃ o̞ˑ ɔ̆ ă ɶ̝ ŭ ʊ̰ː o̰ uu̯ uɪ ã ɐ a ɨː iː o̥ ʌ wə uj ũj u̯ ɔ̃ u͓ e l ɫ l̥ l̩ u̠ ɒ ɵ',
  'uˑ': 'u uː u̥ ũ ʊˑ',
  'u˞': 'ʊ ʊ̥ ɔ ɔ̥ ui y u',
  'uˤ': 'u',
  'ʊ̈': 'ʊ ou o ʊ̥ ʊ̃̈ ʉ u',
  'ʊ̆': 'ʊ ʊ̃ ʊ̥̆ u w ŭ uː o',
  'ʊ̃': 'ʊ u ũ w ʊ̆ ʊ̥̆ o ɔ ʊ˞ ɔ̃ ɯ̞̃ uɪ ʊ̥ ʊː y',
  'ʉ̯̃': 'ŋ ɨ̯̃',
  'ũˤ': 'ũ',
  'ʊ̃̈': 'ʊ̈',
  'ʊ̜': 'ɪ',
  'ʊ̟': 'ʊ u',
  'ʊ̤': 'ʊ o',
  'ʊ̥': 'ʊ o ʊ˞ u u˞ ɔ ɔ̥ ui y ʊ̈ ʊ̃ u̥',
  'ʊ̪': 'v ʋ v̥',
  'ʊ̯': 'w',
  'ʊ̰': 'ʊ ʊː ʊ̰ː ʌ',
  'ʊ̥̆': 'ʊ ʊ̆ ʊ̃ w u',
  'ʊˑ': 'uˑ',
  'ʊ˞': 'ʊ o ʊ̥ u ʊ̃',
  'ʊˤː': 'ʊːɒ̯ˤ',
  'uː': 'u ʊ ũ oː ũː ʊː ṵː uˑ ʉː ɯː ŭ ɨ iː w uə oːu õː ʊ̆ ɔː u̟ː yː uə̯ ʊu ṳː i ɪ ɨː y ə ɯ ɤ ʷuː o u̯ uˤː ɥː u͓ əː eː ʉ ɵʊ uʔ',
  'üː': 'üʲ ʉ̈ʲ ʉ̈ː ü ʉ̈',
  'ũː': 'uː õː u ũ',
  'ʉː': 'uː yː ʉ ʉ̠ː y',
  'ʉ̈ː': 'üʲ ʉ̈ʲ üː ü ʉ̈',
  'u̟ː': 'uː',
  'ṳː': 'uː',
  'u̥ː': 'u ɯ',
  'ṵː': 'uː ɔː ʊː',
  'ʉ̠ː': 'ʉː',
  'uˤː': 'uː',
  'ʊːɒ̯ˤ': 'ʊˤː',
  'ua': 'o̞ uɔ ɔ ɣua ʊɛ ʊa',
  'ʊa': 'ua ʊɛ',
  'uɔ': 'ɔ ua',
  'ue': 'ɣue',
  'uə': 'uː',
  'uɘ': 'u v̩ u̥ ʊ f̩',
  'uə̯': 'uː',
  'ʊə̯': 'u o',
  'uɛ': 'ɔ ɔ̃',
  'ʊɛ': 'ua ʊa',
  'ui': 'ʊ̥ u˞ ɔ ɔ̥ y ʊ ʊɨ u',
  'uɪ': 'ʊ ʊ̃ u ɯ ɔ',
  'ũi': 'ũ',
  'ṳi': 'ṳ',
  'ʊi': 'oi',
  'ʊɨ': 'ui',
  'uie': 'ɥie',
  'uiɛ': 'ɥiɛ',
  'uj': 'ʊ u ũj u̯',
  'üʲ': 'ʉ̈ʲ üː ʉ̈ː ü ʉ̈',
  'ũj': 'ʊ u uj u̯',
  'ʉ̈ʲ': 'üʲ üː ʉ̈ː ü ʉ̈',
  'uo': 'o ɔ',
  'uø': 'øː',
  'uo̞': 'o̞ə̯ o̞i o̞ɔ̯ ɵ o̞ io̞',
  'uu̯': 'o ʊ u ɣ',
  'uʊ̯': 'u',
  'ʊu': 'u ʊ uː',
  'uʔ': 'u ũ uː ṵ ʉ',
  'v': 'f w β vʲ b vʷ ʋ ɸ v̥ f͉ bv p vˠ ṽ β̞ ʍ ɰ vʷˠ vˑ b̪ vː ɱv fʷ fʲ ɯ̆ ɰ̥ βʲ w̃ w̟ p̚ u bʷ bʲ ɱ ɱvʷ vf ɣʷ ð d̪ ð̥ v̩ mb v̼ ʊ̪ vv̥',
  'ṽ': 'v β w̃ vʷ w m',
  'v̠': 'b β bʲ',
  'v̥': 'v f w ɸ v̩ ʋ ʊ̪',
  'v̩': 'u u̥ ʊ f̩ uɘ v f ɸ v̥',
  'v̼': 'ɸ β v f',
  'v͈': 'f',
  'ʋ': 'w v β β̞ ɹ ɥ u ɸ b f͉ b̪ ʋ̃ ʋʲ wʱ ʍ ɯ β̞̜ pʰ bʲ bʷ ɾ z s l ɫ ʔ vː r ʁ ʀ f v̥ ʊ̪ vv̥',
  'ʌ': 'a ə ɑ æ ɛ ɔ a̟ ã o ɒ ɜ ɐ e ɤ aˑ õ ə̤ ʌː ə̥̆ ə̆ ə̥ ʌ̥ ʌ̯ ʀ r ɯ̞̥̆ ɯ̞ ɑː ai au oː ɛʌ aɪ ɔ̃ ɑi ɑ̃ ʌ̃ ɔ̰ ʊ ʊ̰ ʌˤ aː ɵ ə̃ ɔː əi ə̤i ɞ',
  'ⱱ': 't ʁ w',
  'vˑ': 'v',
  'ʌ̆': 'ɑ a aː',
  'ʋ̃': 'w ʋ β̞',
  'ʌ̃': 'ɔ̃ ɤ̞̃ õ ɤ̃ õ̞ ã ŋ ʌ',
  'ʌ̥': 'ʌ',
  'ʌ̯': 'r ɜ̯ ɵ̞̯ ɘ̯ ʌ ʀ ɐ̯',
  'vː': 'v ʋ vv̥ː ʋː',
  'ʋː': 'vː vv̥ː',
  'ʌː': 'aː a ʌ ã ɑː',
  'ʌ̃ː': 'õː ɔ̃ː õ̞ː ɤ̞̃ː ɤ̃ː',
  'vf': 'v bv',
  'vˠ': 'v vʷˠ w',
  'vʱ': 'wʱ',
  'ʌi': 'ai',
  'vʲ': 'v vʷ β βʲ f fʷ fʲ β̞ʲ w',
  'ʋʲ': 'ʋ',
  'ʌʊ': 'au oʊ',
  'vv̥': 'v ʋ w',
  'vv̥ː': 'vː ʋː',
  'vʷ': 'v vʲ w ṽ w̃ f fʷ fʲ',
  'vʷˠ': 'v vˠ w',
  'w': 'v u w̃ β ɥ ʍ ʋ b wː β̞ ɣʷ ʊ m ŋʷ ũ j ŋ w̥ f p ɸ o̯ ɰ ʊ̯ ɡʷ o w̰ ʊ̃ θ wʲ ɔ̯ vʷ ʔ uː y h ɡ ʔw p̚ u̯ ŋw̃ v̥ ɯ̆ w̰̃ ʊ̆ ʊ̥̆ βʲ vʷˠ vˠ o̞̯ ɣ̃ʷ ṽ nʷ βʷˠ βˠ u̥ ʋ̃ w̆ ɣ ʉ ø jw tʰ pʰ kʰ β̃ wʱ wʊ ɥ̃ xʷ mb β̞̜ ɰʷ ɓ ŋm ŭ ŏ wiy ẅiy o̝ ɔ ə b̥ ɹ w̹ vʲ ⱱ ɒ œ ö vv̥',
  'w̆': 'w',
  'w̃': 'w m ɥ ŋ w̰ ɥ̃ β o̯ w̰̃ m̥ b ṽ v vʷ nʷ βʷˠ mː β̃ wʔ ŋʷ ŋw̃ ɔ̃ ũ u',
  'wˀ': 'ʔ ɠ',
  'w̟': 'v β',
  'w̥': 'w',
  'w̰': 'w w̃ w̰̃ ˀw̥ ʍ wʔ',
  'w̹': 'w',
  'w̰̃': 'w w̰ w̃',
  'ʍ': 'w h v β ɸ ɯ̆ w̰ ʋ u ʍʲ β̞',
  'ˀw̥': 'w̰',
  'ˀw̰': 'ʔŋ̰ʷ',
  'wː': 'w w̃ː',
  'w̃ː': 'wː',
  'wa': 'a ja jwa ɔ',
  'ʷd': 'd dʲ dʷʲ',
  'ʷɗ': 'ɗ ɗʲ ɗʷʲ',
  'ʷdz': 'dz dzʲ dzʷʲ',
  'wə': 'ə jə jwə u ʊ wʊ',
  'ʷɣ': 'ɣ ɣʲ ɣʷʲ',
  'ʷɡ': 'ɡ ɡʲ ɡʷʲ',
  'wʱ': 'vʱ w β ʋ',
  'wiy': 'u ẅiy w ŋʷ',
  'ẅiy': 'u wiy w ŋʷ',
  'wʲ': 'w p',
  'ʍʲ': 'ʍ h',
  'ʷk': 'k kʲ kʷʲ',
  'ʷɬ': 'ɬ ɬʲ ɬʷʲ',
  'ʷɮ': 'ɮ ɮʲ ɮʷʲ',
  'ʷŋ': 'ŋ ŋʲ ŋʷʲ',
  'ʷo': 'o',
  'ʷoː': 'oː',
  'ʷs': 's sʲ sʷʲ',
  'ʷt': 't tʲ tʷʲ',
  'ʷts': 'ts tsʲ tsʷʲ',
  'ʷu': 'u ʉ',
  'wʊ': 'u ʊ w wə',
  'ʷuː': 'uː',
  'ʷx': 'x xʲ xʷʲ',
  'ʷz': 'z zʲ zʷʲ',
  'wʔ': 'w̰ w̃',
  'ʷʔ': 'ʔ ʔʲ ʔʷʲ',
  'x': 'h ɣ k ç χ xʷ kʰ ɡ xʲ ɦ k̚ q kx kⁿ xː x̟ ʔ xˠ ɦ̃ c qʰ qχ xˑ xʀ̥ ʁ ʀ̥ ɣ̟ ɣʷ ø kʲ r ɾ ɹ ɐ̯ ɦ̥ ŋɡ ʷx xʷʲ ɸ hʷ χ̃ ħ ʝ x͉ ʁ̥ ʃ f',
  'x̟': 'x h χ ç ʀ̥',
  'x͉': 'x ʁ̥',
  'xˑ': 'ɣ xʷ x xʀ̥ ɣˑ',
  'xː': 'x h xʷː xːʀ̥ xʷ χː ʃ ç ɸ çː ɸː',
  'x͈ː': 'x͈ʷː',
  'xːʀ̥': 'xʷː xː',
  'xˠ': 'xʷ x',
  'xʲ': 'x xʷ ɣ hʲ h ʷx xʷʲ',
  'xk': 'ʰk',
  'xʀ̥': 'xˑ xʷ x',
  'xw': 'h ɦ',
  'xʷ': 'x hʷ xʲ ç xˠ xˑ xʀ̥ ɣ w xː χʷ h',
  'xʷː': 'xːʀ̥ xː',
  'x͈ʷː': 'x͈ː',
  'xʷʲ': 'x ʷx xʲ',
  'y': 'u i yː ʊ ʏ ɥ ɪ ũ w œ y̥ ʊ̥ u˞ ɔ ɔ̥ ui i̥ ĭ̥ ĭ ʏ̥̆ ʉ uː ø j ʒ ʔy ʔd̠ʒ iː ỹ ʊ̃ ʉː yˑ <y>',
  'ʏ': 'ɪ y i ʊ u œ ə ɯ ɪ̃̈ iː ɪ̈ ɤ ʏ̥̆ ø œ̝ ɨ ɵ ʏː',
  'y̆': 'ɔ̆ ø̆ ŭ',
  'ỹ': 'ũ y ĩ',
  'y̥': 'y',
  'ʏ̥̆': 'ʏ y',
  'ʎ': 'l l̥ʲ ɭ l̪ ʎ̥ d dl ɽ j lˠ lː ɾ lʲ',
  'yˑ': 'yː y',
  'ʎ̟': 'l̪ l',
  'ʎ̥': 'ʎ l̥',
  'yː': 'y uː yə̯ ʉː yə yˑ',
  'ʏː': 'œ œː ø̞ ʏ',
  'ʎː': 'ʝː',
  'yaː': 'aː ɔː',
  'yə': 'yː',
  'yə̯': 'yː',
  'ʎʲ': 'ɬ',
  'z': 's ʒ dz d̠ʒ zʲ z̥ s͉ zʷ ʃ ts j zː d zˤ ɾ sː nz ð t̠ʃ ɕ ʑ d̠ʒʲ ʝ e̯ ʃ͈ s͈ n ŋ z̃ ʒ̃ zˠ zʷˠ r l ɟ zd̪ zʰ s̰ ʒʷ ʷz zʷʲ ɟʝ ʒʲ dzs d̠ʒʃ zs ʒʃ sʷ z̻ ɹ ʋ d̪ n̪d̪ dʑ s̪',
  'z̃': 'z ʒ ʒ̃',
  'ʐ': 'ɖʐ ɾ ʒ ʂ r ɽ d̠ʒ ʐˀ s ɾ̥ ð ʐd̪ ʐʰ',
  'z̥': 'z s ʒ',
  'z̩': 'ɹ̩ ʒ̩',
  'z̪': 's̪ dz s̪͉ z̪ʲ ʒ z̪̥',
  'z̺': 's̺',
  'z̻': 'ɲ d̻ t̻ t̻̚ s̻ ɟ j z dz zʲ s',
  'z͇': 'ɾ r z͇̥',
  'z͈': 's',
  'ʑ': 'ʒ dʑ z ʑʰ dz ʒ̊ ʃ ʁ ə ɐ χ d̠ʒ',
  'zˤ': 'z',
  'ʐˀ': 'ʐ',
  'z̃ˑ': 'n nˑ nː',
  'z̞̩': 'ɨ i̥ ɻ̩ i s̞̩ ɻ̥̩',
  'z̪̥': 'z̪ s̪',
  'ʐ͇': 'ʂ͇ ɻ ɾ ɻ̥ r̠',
  'z͇̥': 'ɾ r z͇',
  'z̪ˤ': 'z̪̥ˤ s̪ˤ',
  'zː': 'z sː s ʒ',
  'z̪ː': 'z̪̥ː s̪ː',
  'z̪̥ː': 'z̪ː s̪ː',
  'z̪ˤː': 'z̪̥ˤː s̪ˤː',
  'z̪̥ˤː': 'z̪ˤː s̪ˤː',
  'zd̪': 'z',
  'ʐd̪': 'ʐ',
  'zˠ': 'zʷˠ z',
  'zʰ': 'z',
  'ʐʰ': 'ʐ',
  'ʑʰ': 'ʑ',
  'zʲ': 'z j sʲ zʷ d̠ʒ d̠ʒʲ sʲː nz ʒ ʷz zʷʲ dz z̻ s',
  'z̪ʲ': 'z̪ ʒ',
  'ʑj': 'j dzj',
  'zs': 'z dz d̠ʒ ʒ dzs d̠ʒʃ ʒʃ',
  'zʷ': 'z zʲ nz',
  'z̞̩ʷ': 'u',
  'zʷˠ': 'zˠ z',
  'zʷʲ': 'z ʷz zʲ',
  'ʒ': 'z d̠ʒ ʃ j dz ʃ͉ ʒː ʒ̥ t̠ʃ s ʒʲ d ʑ ʃʲ ʐ ʒ̃ ts ʒʷ ʒ̊ ʒ̩ ʃː r j̃ ʒˤ z̃ ʄ ɕ sʲ h z̪ z̪ʲ t n t̪ tˠ d̪ s̪ z̥ s̰ d̠ʒ̥ ʔy ʔd̠ʒ y zʲ ɟʝ dzs d̠ʒʃ zs ʒʃ ʃʷ k zː',
  'ʒ̃': 'ʒ j̃ j z z̃',
  'ʒ̊': 'ʒ ʑ ʃ d̠ʒ',
  'ʒ̥': 'ʒ ʃ d̠ʒ',
  'ʒ̩': 'ʒ ɹ̩ z̩',
  'ʒ͈': 'ʃ',
  'ʒˤ': 'ʒ ʒ̥ˤ ʃˤ',
  'ʒ̥ˤ': 'ʒˤ ʃˤ',
  'ʒː': 'ʒ ʃː ʃ ʒˤː ʒ̥ː',
  'ʒ̥ː': 'ʒː ʃː',
  'ʒˤː': 'ʒː ʒ̥ˤː ʃˤː',
  'ʒ̥ˤː': 'ʒˤː ʃˤː',
  'ʒʲ': 'ʒ d̠ʒ ʃʲ t̠ʃ͉ z',
  'ʒʃ': 'z dz d̠ʒ ʒ dzs d̠ʒʃ zs',
  'ʒʷ': 'ʒ jʷ z',
  'ʔ': 'k ɡ h t tʰ ɾ ʔʷ k̚ ʔʲ q tʔ ɦ ʔʰ ʔ̚ t̚ ɰ ʔː w ʁ kʰ kʲ kʷ x kx p d ts ɹ ʔt ʁ̞ wˀ ɠ ŋk ˀb ʕ ɢ q̚ kʼ s ʔⁿ ʔ̃ ʷʔ ʔʷʲ b c ɟ tⁿ tˡ θ ð ʰsʰ pʰ pʔ ʔp kʔ ʔk d̰ t̃ ʋ qʼ χʼ qʼχ ʁ̥ χ ɐ ∅ t̠ ʈ t̠ʔ ʈʔ d̠ ɖ t̠̚ ʈ̚',
  'ʕ': 'ʁ ɣ ɡ ɡʲ k ʔ ɢ ʁʲ ɥ ʕˀ ʕ̥ ʜ',
  'ʔ̃': 'ʔ',
  'ʕˀ': 'ʕ',
  'ʔ̚': 'ʔ ʔⁿ k kx ∅',
  'ʕ̥': 'ʕ ʜ',
  '˧˩̰ʔ': '˧˩̰',
  'ʔː': 'ʔ ʔʰ',
  'ʕː': 'ʕ̥ː ʜː',
  'ʕ̥ː': 'ʕː ʜː',
  'ʔɒ': 'ɒ ɒ̃ ɒː',
  'ʔæ': 'æ æː æ̃',
  'ʔb': 'b ɓ',
  'ʔɓ': 'ɓ ʔm̰ ʔp̚',
  'ʔc̟̚': 'tɕ ʔc̟ʰ ʔtɕ̚',
  'ʔc̟ʰ': 'tɕ ʔc̟̚ ʔtɕ̚',
  'ʔd': 'ɗ',
  'ʔᶑ': 'ᶑ ʔl̰ ʔn̰',
  'ʔd̪': 'd̪',
  'ʔd̠ʒ': 'ʒ ʔy y',
  'ʔe': 'e eː ẽ',
  'ʔʰ': 'ʔ ʔː',
  'ʔi': 'i ĩ iː',
  'ʔj': 'j',
  'ʔʲ': 'ʔ c ʔʷ ɗ ɗʲ ɗ̥ j ʷʔ ʔʷʲ',
  'ʔk': 'k kʰ kʔ kx ʔ ɡ̰ k̃ ʰk',
  'ʔk̚': 'k ŋʔk̚',
  'ʔl': 'l',
  'ʔl̰': 'ᶑ ʔᶑ ʔn̰',
  'ʔm': 'm mb ˀb͉',
  'ʔm̰': 'ɓ ʔɓ ʔp̚',
  'ʔn': 'n n̪ nd',
  'ʔⁿ': 'ʔ ʔ̚',
  'ʔn̰': 'ᶑ ʔᶑ ʔl̰',
  'ʔɲ̰': 'ˀj̰',
  'ʔŋ̰ʷ': 'ˀw̰',
  'ʔo': 'o oː õ',
  'ʔp': 'p pʰ pʔ ʔ b̰ p̃ ʰp',
  'ʔp̚': 'ɓ ʔm̰ ʔɓ p mʔp̚',
  'ʔr': 'r ɾ',
  'ʔʃ': 't̠ʃ ʃ ʔt̠ʃ',
  'ʔt': 'tʰ t tʔ ʔ t̺ t̺β ts ɾ d̰ t̃ t̚',
  'ʔt̻̚': 't̻ nʔt̻̚ t̺',
  'ʔtɕ̚': 'tɕ ʔc̟̚ ʔc̟ʰ',
  'ʔt̠ʃ': 't̠ʃ ʃ ʔʃ',
  'ʔw': 'w ɣʷ',
  'ʔʷ': 'ʔ k̚ k ʔʲ',
  'ʔ̚ʷ': 'b ˀp',
  'ʔʷʲ': 'ʔ ʷʔ ʔʲ',
  'ʔy': 'ʒ ʔd̠ʒ y',
  'β': 'b w p v ɸ f p̚ bʷ b̚ β̞ ʋ ɓ βʲ pʰ βʷ b̥ pʲ ʍ ɰ βː b̤ bʲ bʱ mb w̃ bː β̥ ɯ̆ bⁿ pɸ bβ ɰ̥ vʲ ṽ pʼ b̤ː m w̟ p̃ β̃ wʱ pʷ pⁿ b̃ p̰ β̞̜ bˠ bɸ v̠ v̼ b̞ b̞̤ ˀβ p͉',
  'β̃': 'b b̃ w β w̃',
  'β̞': 'w b β ʋ p v j m ɓ ʋ̃ ɥ β̞̜ ʍ β̞ː',
  'β̥': 'β b b̥',
  'β̞̃': 'm bm mb',
  'β̞̜': 'w ʋ β β̞',
  'β̞̤̃': 'm̤',
  'ˀβ': 'β',
  'βː': 'b β',
  'β̞ː': 'β̞',
  'βˠ': 'ɣʷ w',
  'βʲ': 'β w v vʲ β̃ʲ ɸ',
  'β̃ʲ': 'βʲ',
  'β̞ʲ': 'vʲ',
  'βʷ': 'β b mb p',
  'βʷˠ': 'w̃ w',
  'θ': 'ð t t̪ t̚ d̪ w j t̪θ d tʰ s θ̬ s̻ˑ s̻ n̪θ t̠θˀ t̪θʰ θˑ ðˑ ɡ ɾ̪ t̪̚ t̪ⁿ t̰ c d̥ ts h ʰsʰ ɹ ɾ ʔ f θː',
  'θʼ': 't̪θʼ',
  'θ͉': 'ð ð̞',
  'θ̬': 'θ',
  'θˑ': 'ð ðˑ θ',
  'θː': 's̻θ θ',
  'θt': 'ʰt',
  'χ': 'x ʁ q k h kʰ ɣ ʀ ç qʰ χʲ ɐ qχ kx ʀ̥ x̟ ʁ̥ ə ɢ χˤ ɡ k̚ q̚ kʷ qʷ kχ χ̃ ʔ ɕ ʑ χʷ',
  'χ̃': 'x χ',
  'χʼ': 'qʼ qʼχ ʔ',
  'χ͉': 'ʁ',
  'χˤ': 'χ',
  'χː': 'χˤː xː χʷː ʁː ʁ̥ː',
  'χˤː': 'χː',
  'χʲ': 'χ',
  'χʷ': 'xʷ χ ʁʷ ʁ ʁ̥ʷ',
  'χʷː': 'χː ʁʷː ʁː ʁ̥ʷː',
}
